<template>
  <div class="custom-order">
    <Breadcrumb />
    <el-tabs
      v-if="user.userType == '00'"
      style="margin: 0 0 -26px 0"
      v-model="activeName"
      type="card"
      @tab-click="getData"
    >
      <el-tab-pane :label="langType ? '全部' : 'All'" name="sum"></el-tab-pane>
      <el-tab-pane
        :label="`${langType ? '生产中' : 'Production'}（${
          orderCount.buildCnt
        }）`"
        name="producing"
      ></el-tab-pane>
      <el-tab-pane
        :label="`${langType ? '已发货' : 'Shipped'}`"
        name="sended"
      ></el-tab-pane>
      <el-tab-pane
        :label="`${langType ? '已取消' : 'Canceled'}（${
          orderCount.cancelCnt
        }）`"
        name="canceled"
      ></el-tab-pane>
      <el-tab-pane
        :label="`${langType ? '挂起' : 'Hanging'}（${orderCount.hangCnt}）`"
        name="hanging"
      ></el-tab-pane>
    </el-tabs>
    <div class="fullscreen">
      <el-switch
        v-model="screenType"
        active-color="#13ce66"
        inactive-color="#ff4949"
        active-text="fullscreen"
        inactive-text="normal"
        @change="handleChangeScreenType"
      >
      </el-switch>
    </div>
    <div class="language">
      <el-switch
        v-model="langType"
        active-color="#13ce66"
        inactive-color="#ff4949"
        active-text="中文"
        inactive-text="English"
        @change="handleChangeLangType"
      >
      </el-switch>
    </div>

    <div class="form-body">
      <el-form :model="form" ref="form" label-width="149px">
        <el-row
          v-if="
            routeName.indexOf('lazada') == -1 &&
            routeName.indexOf('shopee') == -1 &&
            routeName.indexOf('tiktok') == -1
          "
          :gutter="20"
        >
          <el-col :span="24">
            <div class="grid-content bg-purple">
              <el-form-item
                :label="langType ? '工厂编号：' : 'Manufacturer:'"
                class="item"
              >
                <div
                  style="
                    max-height: 200px;
                    overflow-y: auto;
                    float: left;
                    width: calc(100% - 59px);
                  "
                >
                  <el-input
                    v-if="isExpand"
                    style="width: 139px; margin: 0 29px 0 0"
                    v-model="manufacturer"
                    size="small"
                    placeholder="langType ? '工厂编号：' : 'Manufacturer:'"
                  ></el-input>
                  <el-checkbox
                    @change="handleChangeManufacturer"
                    v-model="isCheckManufacturer"
                    >全选</el-checkbox
                  >
                  <el-checkbox-group
                    filterable
                    v-model="form.manufacturer"
                    class="input"
                    size="small"
                    clearable
                    style="display: inline; margin: 0 0 0 27px"
                  >
                    <el-checkbox
                      v-for="(item, index) in dictData['MANUFACTURER']"
                      :key="index"
                      :label="item.value"
                      v-show="
                        (isExpand || index < 10) &&
                        item.label.indexOf(manufacturer) > -1
                      "
                    >
                      {{ item.label }}
                    </el-checkbox>
                  </el-checkbox-group>
                </div>
                <div
                  v-if="dictData['MANUFACTURER'].length > 10"
                  @click="isExpand = !isExpand"
                  style="
                    margin: 0 0 0 16px;
                    cursor: pointer;
                    color: #4934b2;
                    float: left;
                  "
                >
                  {{ isExpand ? "－收起" : "＋展开" }}
                </div>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
        <el-row
          v-if="
            activeName == 'sum' && currentPathName && currentPathName != 'orderFlb'
          "
          :gutter="20"
        >
          <el-col :span="24">
            <div class="grid-content bg-purple">
              <el-form-item label="第三方状态：" class="item">
                <el-checkbox
                  @change="handleChangeAmazonStatus"
                  v-model="isCheckAmazonStatus"
                  >全选</el-checkbox
                >
                <el-checkbox-group
                  clearable
                  v-model="form.amazonOrderStatus"
                  placeholder="请选择订单状态"
                  class="input"
                  size="small"
                  style="display: inline; margin: 0 0 0 27px"
                >
                  <el-checkbox
                    v-for="value in dictData[currentPathName + '_status']"
                    :key="value.value"
                    :label="value.value"
                    >{{ value.label }}/{{ value.remark }}
                  </el-checkbox>
                </el-checkbox-group>
              </el-form-item>
            </div>
          </el-col>
        </el-row>

        <el-row
          v-show="
            currentPathName == 'orderFlb' && activeName == 'sum'
          "
          :gutter="20"
          v-for="(v, k) in allThirdStatus"
          :key="k"
        >
           <el-col :span="24">
            <div class="grid-content bg-purple">
              <el-form-item :label="`第三方状态(${v.name})：`" class="item">
                <el-checkbox
                  @change="handleChangeAllThirdStatus(v.name)"
                  v-model="isCheckAllThirdStatus[v.name]"
                  >全选</el-checkbox
                >
                <el-checkbox-group
                  clearable
                  v-model="thirdOrderStatus[v.name]"
                  placeholder="请选择订单状态"
                  class="input"
                  size="small"
                  style="display: inline; margin: 0 0 0 27px"
                >
                  <el-checkbox
                    v-for="value in v.data"
                    :key="value.value"
                    :label="value.value"
                    >{{ value.label }}/{{ value.remark }}
                  </el-checkbox>
                </el-checkbox-group>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <div class="grid-content bg-purple">
              <el-form-item
                :label="langType ? `订单编号(订单数:${appNosCount})：` : `Order No(Order Count:${appNosCount}):`"
                class="item"
              >
                <el-input
                  class="batch_inputbox input"
                  v-if="!showAppNosTextarea"
                  placeholder="多单号查询请用英文逗号隔开"
                  v-model="form.appNos"
                  size="small"
                  clearable
                />
                <span
                  @click="handleShowAppsNos"
                  v-if="!showAppNosTextarea"
                  class="batch_txt btnIconDown"
                >
                  批量
                </span>
                <div class="textareaBox">
                  <el-input
                    v-if="showAppNosTextarea"
                    type="textarea"
                    :rows="6"
                    placeholder="换行可批量（无需逗号结尾）"
                    v-model="appNos"
                    show-word-limit
                    maxlength="3000"
                    @blur="handleAppNosBlur"
                  >
                  </el-input>
                </div>
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="grid-content bg-purple">
              <el-form-item
                :label="langType ? '接单时间：' : 'Receipt Time:'"
                class="item"
              >
                <el-date-picker
                  type="daterange"
                  placeholder="选择日期"
                  v-model="form.lineTime"
                  class="input"
                  size="small"
                  :range-separator="langType ? '至' : 'to'"
                  :start-placeholder="langType ? '开始日期' : 'begin'"
                  :end-placeholder="langType ? '结束日期' : 'end'"
                  value-format="yyyy-MM-dd"
                  :picker-options="pickerOptions"
                  clearable
                ></el-date-picker>
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="grid-content bg-purple">
              <el-form-item
                :label="langType ? '发货时间：' : 'Shipped Time:'"
                class="item"
              >
                <el-date-picker
                  type="daterange"
                  placeholder="选择日期"
                  v-model="form.sendTime"
                  class="input"
                  size="small"
                  :range-separator="langType ? '至' : 'to'"
                  :start-placeholder="langType ? '开始日期' : 'begin'"
                  :end-placeholder="langType ? '结束日期' : 'end'"
                  value-format="yyyy-MM-dd"
                  :picker-options="pickerOptions"
                  clearable
                ></el-date-picker>
              </el-form-item>
            </div>
          </el-col>
          <el-col
            v-if="
              routeName.indexOf('lazada') == -1 &&
              routeName.indexOf('shopee') == -1 &&
              routeName.indexOf('tiktok') == -1
            "
            :span="8"
          >
            <div class="grid-content bg-purple">
              <el-form-item
                :label="langType ? '平台渠道：' : 'Channel:'"
                prop="platNo"
              >
                <el-select
                  clearable
                  v-model="form.platNo"
                  :placeholder="langType ? '请选择平台渠道' : ''"
                  class="input"
                  style="width: 100%"
                  size="small"
                  multiple
                  filterable
                >
                  <el-option
                    v-for="(value, index) in dictData['plat_no']"
                    :key="index"
                    :label="value.label"
                    :value="value.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="grid-content bg-purple">
              <el-form-item
                :label="langType ? '标记类型：' : 'Remark Type:'"
                class="item"
              >
                <el-select
                  clearable
                  v-model="form.orderRemarkType"
                  placeholder="请选择标注类型"
                  class="input"
                  size="small"
                  multiple
                  filterable
                >
                  <el-option
                    v-for="(value, index) in dictData['remarkType']"
                    :key="index"
                    :label="value.label"
                    :value="value.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="grid-content bg-purple">
              <el-form-item
                :label="langType ? '标记颜色：' : 'Remark Color:'"
                class="item"
              >
                <el-select
                  clearable
                  v-model="form.orderRemarkColor"
                  placeholder="请选择标记类型"
                  class="input"
                  size="small"
                  multiple
                  filterable
                >
                  <template
                    lable="99"
                    v-for="(value, key) in textColorList"
                    :value="key"
                  >
                    <el-option
                      :key="value.hex"
                      :label="value.name"
                      :value="value.hex"
                    >
                      <div
                        class="background-color-item"
                        :style="{ background: value.hex }"
                        style="position: relative"
                      ></div>
                      <div class="background-color-text">{{ value.name }}</div>
                    </el-option>
                  </template>
                </el-select>
              </el-form-item>
            </div>
          </el-col>
          <el-col
            :span="8"
            v-if="
              routeName.indexOf('lazada') == -1 &&
              routeName.indexOf('shopee') == -1 &&
              routeName.indexOf('tiktok') == -1
            "
          >
            <el-form-item
              :label="langType ? '所属国家：' : 'Country'"
              prop="state"
            >
              <el-select
                clearable
                multiple
                v-model="form.state"
                placeholder="请选择"
                size="small"
                style="width: 100%"
              >
                <el-option
                  v-for="(value, index) in dictData['country_site']"
                  :key="index"
                  :label="value.label"
                  :value="value.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              :label="langType ? '是否下载：' : 'Is Download:'"
              prop="downloadFlag"
            >
              <el-select
                clearable
                v-model="form.downloadFlag"
                placeholder="请选择"
                size="small"
                style="width: 100%"
              >
                <el-option label="已下载" value="01"> </el-option>
                <el-option label="未下载" value="02"> </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col
            v-if="
              routeName.indexOf('lazada') == -1 &&
              routeName.indexOf('shopee') == -1 &&
              routeName.indexOf('tiktok') == -1
            "
            :span="8"
          >
            <el-form-item
              :label="langType ? '产品ID：' : 'Product ID:'"
              prop="productId"
            >
              <el-input
                v-model="form.productId"
                placeholder="请输入产品ID"
                size="small"
                clearable
                style="width: 100%"
              />
            </el-form-item>
          </el-col>

          <el-col
            v-if="
              routeName.indexOf('lazada') == -1 &&
              routeName.indexOf('shopee') == -1 &&
              routeName.indexOf('tiktok') == -1
            "
            :span="8"
          >
            <div class="grid-content bg-purple">
              <el-form-item
                style="position: relative"
                label="删除订单编号："
                class="item"
              >
                <el-input
                  class="batch_inputbox input"
                  v-if="!showAppNosTextareaDel"
                  placeholder="多单号查询请用英文逗号隔开"
                  v-model="form.appNoDels"
                  size="small"
                  clearable
                />
                <span
                  @click="handleShowAppsNosDel"
                  v-if="!showAppNosTextareaDel"
                  class="batch_txt btnIconDown"
                >
                  批量
                </span>
                <div class="textareaBox">
                  <el-input
                    v-if="showAppNosTextareaDel"
                    type="textarea"
                    :rows="6"
                    placeholder="换行可批量（无需逗号结尾）"
                    v-model="appNoDels"
                    show-word-limit
                    maxlength="3000"
                    @blur="handleAppNosBlurDel"
                  >
                  </el-input>
                </div>
              </el-form-item>
            </div>
          </el-col>
          <el-col
            v-if="
              routeName.indexOf('lazada') == -1 &&
              routeName.indexOf('shopee') == -1 &&
              routeName.indexOf('tiktok') == -1 &&
              user.userType == '00'
            "
            :span="8"
          >
            <div class="grid-content bg-purple">
              <el-form-item label="商家账号：" class="item">
                <el-select
                  clearable
                  size="small"
                  multiple
                  v-model="form.pOperNo"
                  filterable
                  remote
                  :remote-method="getAccountList"
                >
                  <template v-for="(value, key) in accountList">
                    <el-option
                      :key="value.userName"
                      :label="`${value.userName}${
                        value.nickName ? '(' + value.nickName + ')  ' : ''
                      }`"
                      :value="value.userName"
                    ></el-option>
                  </template>
                </el-select>
              </el-form-item>
            </div>
          </el-col>
          <!-- <el-col
            v-if="
              routeName.indexOf('lazada') == -1 &&
              routeName.indexOf('shopee') == -1 &&
              routeName.indexOf('tiktok') == -1
            "
            :span="
              routeName.indexOf('lazada') == -1 &&
              routeName.indexOf('shopee') == -1 &&
              routeName.indexOf('tiktok') == -1
                ? 16
                : 8
            "
          >
            <div style="margin-top: 8px" class="item right">
              <el-button type="primary" size="small" @click="getData(1)">
                <span>{{ langType ? "搜索" : "Search" }}</span></el-button
              >
              <el-button type="default" size="small" @click="reset">
                <span>{{ langType ? "重置" : "Reset" }}</span></el-button
              >
            </div>
          </el-col> -->
        </el-row>
        <el-row
          :gutter="20"
          style="margin: -16px 0 0 0"
          v-if="
            routeName.indexOf('lazada') > -1 ||
            routeName.indexOf('shopee') > -1 ||
            routeName.indexOf('tiktok') > -1
          "
        >
          <el-col style="padding-left: 0px" :span="8">
            <el-form-item
              class="item"
              :label="langType ? '产品ID：' : 'Product ID:'"
              prop="productId"
            >
              <el-input
                v-model="form.productId"
                placeholder="请输入产品ID"
                size="small"
                clearable
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <div class="grid-content bg-purple">
              <el-form-item
                style="position: relative"
                label="删除订单编号："
                class="item"
              >
                <el-input
                  class="batch_inputbox input"
                  v-if="!showAppNosTextareaDel"
                  placeholder="多单号查询请用英文逗号隔开"
                  v-model="form.appNoDels"
                  size="small"
                  clearable
                />
                <span
                  @click="handleShowAppsNosDel"
                  v-if="!showAppNosTextareaDel"
                  class="batch_txt btnIconDown"
                >
                  批量
                </span>
                <div class="textareaBox">
                  <el-input
                    v-if="showAppNosTextareaDel"
                    type="textarea"
                    :rows="6"
                    placeholder="换行可批量（无需逗号结尾）"
                    v-model="appNoDels"
                    show-word-limit
                    maxlength="3000"
                    @blur="handleAppNosBlurDel"
                  >
                  </el-input>
                </div>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <div class="grid-content bg-purple">
              <el-form-item label="订单时间：" class="item">
                <el-date-picker
                  type="daterange"
                  placeholder="选择日期"
                  v-model="form.orderTime"
                  class="input"
                  size="small"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                  :picker-options="pickerOptions"
                  clearable
                ></el-date-picker>
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="grid-content bg-purple">
              <el-form-item
                style="position: relative"
                label="剔除商户号："
                class="item"
              >
                <el-input
                  class="batch_inputbox input"
                  v-if="!showMerchantTextareaDel"
                  placeholder="多单号查询请用英文逗号隔开"
                  v-model="form.noMerchant"
                  size="small"
                  clearable
                />
                <span
                  @click="handleShowMerchantsNosDel"
                  v-if="!showMerchantTextareaDel"
                  class="batch_txt btnIconDown"
                >
                  批量
                </span>
                <div class="textareaBox">
                  <el-input
                    v-if="showMerchantTextareaDel"
                    type="textarea"
                    :rows="6"
                    placeholder="换行可批量（无需逗号结尾）"
                    v-model="noMerchant"
                    show-word-limit
                    maxlength="3000"
                    @blur="handleMerchantBlurDel"
                  >
                  </el-input>
                </div>
              </el-form-item>
            </div>
          </el-col>

           <el-col :span="8">
            <div class="grid-content bg-purple">
              <el-form-item
                style="position: relative"
                :label="`运单号：(订单数：${trackingCodeCount})`"
                class="item"
              >
                <el-input
                  class="batch_inputbox input"
                  v-if="!showTrackingCodeTextareaDel"
                  placeholder="多单号查询请用英文逗号隔开"
                  v-model="form.trackingCode"
                  size="small"
                  clearable
                />
                <span
                  @click="handleShowTrackingCodeNosDel"
                  v-if="!showTrackingCodeTextareaDel"
                  class="batch_txt btnIconDown"
                >
                  批量
                </span>
                <div class="textareaBox">
                  <el-input
                    v-if="showTrackingCodeTextareaDel"
                    type="textarea"
                    :rows="6"
                    placeholder="换行可批量（无需逗号结尾）"
                    v-model="trackingCode"
                    show-word-limit
                    maxlength="3000"
                    @blur="handleTrackingCodeBlurDel"
                  >
                  </el-input>
                </div>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item
            class="item"
            :label="langType ? '备注：' : 'Batch remark:'"
            prop="adminRemark"
          >
            <el-input
              v-model="form.adminRemark"
              placeholder="请输入备注"
              size="small"
              clearable
              style="width: 100%"
            />
          </el-form-item>
          </el-col>
          <el-col :span="16">
              <div style="" class="item right">
                <el-button type="primary" size="small" @click="getData(1)">
                  <span>{{ langType ? "搜索" : "Search" }}</span></el-button
                >
                <el-button type="default" size="small" @click="reset">
                  <span>{{ langType ? "重置" : "Reset" }}</span></el-button
                >
              </div>
          </el-col>
        
        </el-row>
      </el-form>
    </div>

    <!-- 表格 -->
    <div class="table-body">
      <div class="top table-menu">
        <div style="overflow: hidden; margin: -4px 0 16px 0">
          <div class="left" style="width: 600px">
            <div
              style="
                float: left;
                display: inline-block;
                margin-right: 8px;
                padding: 4px 0 0 0;
              "
            >
              {{ langType ? "排序" : "order by" }}：
            </div>
            <el-select
              style="float: left; width: 200px; margin-right: 16px"
              size="small"
              v-model="form.sortType"
              placeholder=""
              @change="getData"
            >
              <el-option
                :label="langType ? '接单时间' : 'Receipt Time'"
                value="f"
              ></el-option>
              <el-option
                :label="langType ? '揽收预警时间' : 'Expire'"
                value="g"
              ></el-option>
              <el-option
                :label="langType ? '实际发货时间' : 'Shipped Time'"
                value="h"
              ></el-option>
            </el-select>
            <i
              @click="handleChangeOrder('desc')"
              :style="{ color: form.sortBy == 'desc' ? '#4934b2' : '#aaaaaa' }"
              style="
                margin: 6px 8px 0 0px;
                font-size: 20px;
                float: left;
                cursor: pointer;
              "
              class="el-icon-bottom"
            ></i>
            <i
              @click="handleChangeOrder('asc')"
              :style="{ color: form.sortBy == 'asc' ? '#4934b2' : '#aaaaaa' }"
              style="
                margin: 6px 16px 0 0;
                font-size: 20px;
                float: left;
                cursor: pointer;
              "
              class="el-icon-top"
            ></i>

            <div
                @click="handleRefreshOrder()"
                style="display: inline-block;color: #4934b2;margin: 6px 16px 0 0px;cursor: pointer;"
            >
              <el-tooltip
                effect="dark"
                :content="`刷新`"
                placement="top-start"
                ><i style=" font-size: 20px;" class="el-icon-refresh" ></i>
              </el-tooltip>
            </div>
          </div>
          <div class="right">
            <pagination
              class="pagination"
              :langType="langType"
              :total="total"
              :page.sync="form.pageNum"
              :limit.sync="form.pageSize"
              @pagination="getData"
            />
          </div>
        </div>

        <div style="overflow: hidden; margin: -4px 0 16px 0">
          <el-button
            size="small"
            @click="exportOrder"
            type="primary"
            style="margin: 0 20px 0 0px; float: left"
          >
            {{ langType ? "导出订单" : "Export order" }}
          </el-button>
          <el-button
            size="small"
            @click="exportOrderTH"
            type="primary"
            style="margin: 0 20px 0 0px; float: left"
          >
            {{ langType ? "导出泰国订单" : "Export th order" }}
          </el-button>

          <el-button
            style="float: left; margin: 0 20px 0 0"
            type="primary"
            size="small"
            @click="batchSend"
          >
            <span>{{ langType ? "批量发货" : "Batch send" }}</span>
          </el-button>
          <el-button
            style="float: left; margin: 0 12px 0 0"
            type="primary"
            size="small"
            @click="batchRemarkEvent"
          >
            <span>{{ langType ? "批量备注" : "Batch remark" }}</span>
          </el-button>
          <el-button
            v-if="
              routeName.indexOf('lazada') == -1 &&
              routeName.indexOf('shopee') == -1 &&
              routeName.indexOf('tiktok') == -1 &&
              routeName.indexOf('jst_order') == -1
            "
            size="small"
            @click="downloadImages"
            type="primary"
            style="margin: 0 16px 0 8px; float: left"
          >
            {{ langType ? "下载原图" : "Download images" }}
          </el-button>
          <el-button
            size="small"
            @click="downloadImagesTH"
            type="primary"
            style="margin: 0 16px 0 4px; float: left"
          >
            {{ langType ? "下载泰国图片" : "Download th images" }}
          </el-button>
          <el-button
            size="small"
            @click="downloadImagesTHNew"
            type="primary"
            style="margin: 0 16px 0 4px; float: left"
          >
            {{ langType ? "下载裁剪图" : "Download th images" }}
          </el-button>
          <el-button
            style="float: left; margin: 0 16px 0 0"
            type="primary"
            size="small"
            @click="batchDownloadPick"
          >
            <span>{{ langType ? "下载拣货单" : "download pick order" }}</span>
          </el-button>
          <el-button
            style="float: left; margin: 0 4px 0 0"
            type="primary"
            size="small"
            @click="batchDownloadCombine"
          >
            <span>{{
              langType ? "下载合并面单" : "download combine order"
            }}</span>
          </el-button>
          <el-button
            style="float: left;"
            type="success"
            size="small"
            @click="batchDownload"
          >
            <span>{{ langType ? "下载图片" : "Download" }}</span>
          </el-button>
        </div>
      </div>
      <el-row style="display: flex; flex-wrap: wrap; background-color: white">
        <el-col
          :span="12"
          style="
            display: flex;
            padding-left: 20px;
            color: #333333;
            font-size: 14px;
            align-items: center;
          "
        >
          <div v-if="rowSelectNum > 0">已选中{{ rowSelectNum }}条数据</div>
        </el-col>
        <el-col :span="12"> </el-col>
      </el-row>

      <el-table
        @selection-change="handleSelectionChange"
        :span-method="objectSpanMethod"
        border
        :data="tableData"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column :label="langType ? '所属国家' : 'State'" prop="state">
          <template slot-scope="scope">
            {{ dictMap["country_site"][scope.row.state] }}
          </template>
        </el-table-column>
        <el-table-column
          :label="langType ? '平台渠道' : 'Channel'"
          prop="shopName"
          width="102"
        >
          <template slot-scope="scope">
            <div
              v-if="scope.row.sOrderRemark && scope.row.sOrderRemark.length > 0"
              style="
                height: 25px;
                width: 25px;
                border-radius: 5px;
                display: inline-block;
                float: left;
                margin: 0 8px 0 0;
                cursor: pointer;
              "
            >
              <el-tooltip
                effect="dark"
                :content="`${
                  scope.row.sOrderRemark[0].remarkType == '99'
                    ? scope.row.sOrderRemark[0].remarkContent
                    : dictMap['remarkType'][
                        scope.row.sOrderRemark[0].remarkType
                      ]
                }`"
                placement="top-start"
              >
                <div
                  style="width: 100%; height: 100%; min-width: 1px"
                  :style="{
                    background: scope.row.sOrderRemark[0].remarkColor,
                  }"
                ></div>
              </el-tooltip>
            </div>
            <span> {{ dictMap["plat_no"][scope.row.platNo] }} </span>
          </template>
        </el-table-column>
        <el-table-column
          :label="
            langType ? '单号/运单号/产品ID' : 'Order No/Track Code/Product Id'
          "
          width="190"
          prop="appNo"
        >
          <template slot-scope="scope">
            {{ langType ? "订单号" : "Order No" }} <br />{{ scope.row.appNo }}
            <br />
            <span v-if="scope.row.trackingCode"
              >{{ langType ? "运单号" : "Track Code" }} <br />{{
                scope.row.trackingCode
              }}</span
            >
            <br />
            <span v-if="scope.row.proCode"
              >{{ langType ? "产品ID" : "Product Id" }} <br />{{
                scope.row.proCode
              }}</span
            >
          </template>
        </el-table-column>
        <el-table-column
          :label="langType ? '主题名称' : 'Product Name'"
          prop="proName"
        >
          <template slot-scope="scope">
            {{ scope.row.proName }}
          </template>
        </el-table-column>
        <el-table-column :label="langType ? '颜色' : 'Color'" prop="color">
        </el-table-column>
        <el-table-column :label="langType ? '尺码' : 'Size'" prop="size">
        </el-table-column>
        <el-table-column :label="langType ? '数量' : 'Quantity'" prop="num">
        </el-table-column>
        <el-table-column
          :label="langType ? '效果图' : 'Design Graph'"
          width="119"
          prop="num"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.picUrl" class="design_flag_container">
              <img
                style="width: 98px; height: 98px; cursor: pointer"
                :src="
                  scope.row.picUrl +
                  '?x-oss-process=image/resize,m_fill,h_98,w_98'
                "
                @click="handleShowDesignMaps(scope.row)"
              />
              <div class="design_flag">{{ scope.row.ifNewDesign == '01' ? '新' : '旧' }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          :label="langType ? '原图' : 'Channel'"
          v-if="false"
          width="119"
          prop="proPrice"
        >
          <template slot-scope="scope">
            <img
              :src="
                (scope.row.maps && scope.row.maps.length > 0
                  ? scope.row.maps[0].picUrl
                  : '') + '?x-oss-process=image/resize,m_fill,h_98,w_98'
              "
              style="width: 98px; height: 98px; cursor: pointer"
              @click="handleShowMaps(scope.row)"
            />
          </template>
        </el-table-column>
        <el-table-column
          :label="langType ? '打印图' : 'Print Graph'"
          width="119"
          prop="proPrice"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.sOrderSkuPrintPic?.length > 0" class="design_flag_container">
              <img
                :src="scope.row.sOrderSkuPrintPic[0].picUrl + '?x-oss-process=image/resize,m_fixed,h_98,w_98'"
                style="width: 98px; height: 98px; cursor: pointer"
                @click="handleShowSkuPics(scope.row)"
              />
              <div class="design_flag">{{ scope.row.ifNewDesign == '01' ? '新' : '旧' }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          :label="langType ? '工厂图' : 'Factory Graph'"
          width="119"
          prop="proPrice"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.sOrderSkuFactoryPic?.length > 0" class="design_flag_container">
              <img
                :src="scope.row.sOrderSkuFactoryPic[0].picUrl + '?x-oss-process=image/resize,m_fixed,h_98,w_98'"
                style="width: 98px; height: 98px; cursor: pointer"
                @click="handleShowFactoryPics(scope.row)"
              />
              <div class="design_flag">{{ scope.row.ifNewDesign == '01' ? '新' : '旧' }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          :label="langType ? '面单信息' : 'Shipping Label'"
          prop="proTotal"
        >
          <template slot-scope="scope">
            <a
              target="_blank"
              :href="scope.row.attachUrl"
              v-if="scope.row.attachUrl"
              >{{ langType ? "查看" : "view" }}
            </a>
          </template>
        </el-table-column>
        <el-table-column
          :label="langType ? '售卖价格/面单费' : 'lowPrice/proFare'"
          prop="lowPrice"
        >
          <template slot-scope="scope">
            {{ scope.row.proTotal }}/{{ scope.row.proFare }}
          </template>
        </el-table-column>
        <el-table-column
          :label="langType ? '收货人' : 'Recipient'"
          width="132"
          prop="proFare"
        >
          <template slot-scope="scope">
            {{ scope.row.addr.receName }}<br />
            {{
              scope.row.addr.mobile
                ? scope.row.addr.mobile
                : scope.row.addr.buyerPhoneNumber
            }}
          </template>
        </el-table-column>
        <el-table-column
          width="90"
          :label="langType ? '是否下载' : 'Is Download'"
          prop="size"
        >
          <template slot-scope="scope">
            {{
              scope.row.downloadFlag == "01"
                ? langType
                  ? "已下载"
                  : "downloaded"
                : langType
                ? "未下载"
                : "not download"
            }}
          </template>
        </el-table-column>
        <el-table-column
          label="收件人/物流"
          align="center"
          :width="tdWidth"
          v-if="!routeName.includes('jst_order') && !routeName.includes('jst_lazada') 
               && !routeName.includes('jst_amazon') && !routeName.includes('jst_tiktok')
          "
        >
          <template slot-scope="scope">
            <div class="loan-wrap">
              <div v-if="scope.row.addr && scope.row.addr.receName">
                {{ scope.row.addr.receName }} （{{
                  dictMap["amazon_site"][scope.row.addr.state]
                }}）
              </div>
              <div v-else>-</div>

              <div
                v-if="
                  scope.row.expreList && scope.row.expreList.length > 0
                "
              >
                <div
                  v-for="(record, index) in scope.row.expreList"
                  :key="index"
                >
                  <div v-if="record.shippingMethodName">
                    <span v-if="scope.row.expreList.length > 1"
                      >{{ index + 1 }}.</span
                    >
                    {{ record.shippingMethodName }}
                    <a
                      v-if="
                        record.shipList && record.shipList.length > 0
                      "
                      style="cursor: pointer"
                      @click="handleShowDetail(record)"
                      >发货详情</a
                    >
                  </div>
                  <div v-if="record.trackingNumber">
                    【<a
                      style="cursor: pointer"
                      @click="handleShowExpre(record, scope.row)"
                      >{{ record.trackingNumber }}</a
                    >】
                    <i
                      title="复制"
                      class="el-icon-document-copy"
                      style="cursor: pointer"
                      @click="copyText(record.trackingNumber)"
                    ></i>
                  </div>
                </div>
              </div>
              <div v-else-if="scope.row.expre">
                <div
                  v-if="
                    scope.row.expre &&
                      scope.row.expre.shippingMethodName
                  "
                >
                  {{ scope.row.expre.shippingMethodName }}
                </div>
                <div
                  v-if="
                    scope.row.expre && scope.row.expre.trackingNumber
                  "
                >
                  【<a
                    style="cursor: pointer"
                    @click="handleShowExpre(scope.row.expre, scope.row)"
                    >{{ scope.row.expre.trackingNumber }}</a
                  >】
                  <i
                    title="复制"
                    class="el-icon-document-copy"
                    style="cursor: pointer"
                    @click="copyText(scope.row.expre.trackingNumber)"
                  ></i>
                </div>
              </div>
              <div>
                <div v-if="scope.row.shippingProviderType">
                  <span style="">{{
                    scope.row.shippingProviderType
                  }}</span>
                </div>
                <div v-if="scope.row.shippingProvider">
                  <span style="">{{ scope.row.shippingProvider }}</span>
                </div>
                <div v-if="scope.row.trackingCode">
                  <span style="">
                    <a
                      style="cursor: pointer"
                      @click="handleShowExpre(scope.row, scope.row)"
                      >{{ scope.row.trackingCode }}</a
                    >
                  </span>
                </div>
              </div>
              <div
                v-if="scope.row.orderStatus == '01' && scope.row.addr"
              >
                <span
                  v-if="
                    scope.row.expreList &&
                      scope.row.expreList.length > 0
                  "
                  @click="handleSelectShip(scope.row)"
                  style="color: #4934b2; cursor: pointer"
                  >修改物流方式</span
                >
                <span
                  v-else
                  @click="handleSelectShip(scope.row)"
                  style="color: red; cursor: pointer"
                >
                  选择物流方式
                </span>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          v-if="false"
          width="119"
          label="收货人电话"
          prop="size"
        >
          <template slot-scope="scope">
            {{
              scope.row.addr.mobile
                ? scope.row.addr.mobile
                : scope.row.addr.buyerPhoneNumber
            }}
          </template>
        </el-table-column>
        <el-table-column
          :label="langType ? '第三方状态/时间' : 'Third Status'"
          width="170"
          prop="shipList"
        >
          <template slot-scope="scope"
            ><div style="color: #4934b2; font-weight: bold">
              {{ scope.row.amazonOrderStatus }}
            </div>
            <div>
              {{ langType ? "订单下单时间" : "Ordered" }} <br />
              {{ scope.row.orderTime }}
            </div>
            <div>
              {{ langType ? "揽收预警时间" : "Expire" }} <br />
              {{ scope.row.slaTimeStamp }}
            </div>
            <div>
              {{ langType ? "实际发货时间" : "Shipped" }} <br />
              {{ scope.row.receiveTime }}
            </div>
            <div>
              {{ langType ? "实际取消时间" : "Canceled" }} <br />
              {{ scope.row.cancelTime }}
            </div>
            <div :style="{ color: scope.row.hintColor }">
              {{ getHourHint(scope.row.slaTimeStamp, scope.row.receiveTime) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          :label="langType ? '状态/时间' : 'Status'"
          width="212px"
          prop="shipList"
          v-if="routeName.indexOf('lazada') == -1 
          && routeName.indexOf('shopee') == -1 
          && routeName.indexOf('tiktok') == -1"
        >
          <!-- <template slot-scope="scope">
            <div>
              {{ GetOrderStatus(scope.row.orderStatus) }}
            </div>
            <div v-if="false">
              <span class="title lw40">
                {{ langType ? "接单" : "Receive" }} </span
              ><br />
              {{ scope.row.lineTime || "-" }}
            </div>
            <div v-if="scope.row.sendTime">
              <span class="title lw40"> {{ langType ? "发货" : "Ship" }} </span
              ><br />
              {{ scope.row.sendTime }}
            </div>
          </template> -->
          <template slot-scope="scope">
            <div class="loan-wrap">
              <div v-if="user.userType == '00' && scope.row.pOperNo">
                {{ scope.row.pOperNo }}
              </div>
              <div>
                {{ dictMap["order_status"][scope.row.orderStatus] }}
              </div>
              <div v-if="scope.row.createTime">
                <span class="title lw40"> 创建 </span>
                ：{{ scope.row.createTime }}
              </div>
              <div v-if="scope.row.payTime">
                <span class="title lw40"> 支付 </span>
                ：{{ scope.row.payTime || "-" }}
              </div>
              <div v-if="scope.row.auditTime">
                <span class="title lw40"> 审核 </span>
                ：{{ scope.row.auditTime || "-" }}
              </div>
              <div v-if="scope.row.sendTime">
                <span class="title lw40"> 发货 </span>
                ：{{ scope.row.sendTime }}
              </div>
              <div v-if="scope.row.orderStatus === '09'">
                <br />
                <el-button
                  type="primary"
                  size="small"
                  @click="goRelate(scope.row)"
                  v-if="user.userType !== '00'"
                >
                  关联产品
                </el-button>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          :label="langType ? '收货人地址' : 'Address'"
          width="119"
          prop="proActPay"
        >
          <template slot-scope="scope">
            {{ scope.row.addr.fullAddr }}
          </template>
        </el-table-column>
        <el-table-column
          :label="langType ? '备注' : 'adminRemark'"
          width="119"
          prop="adminRemark"
        >
          <template slot-scope="scope">
            {{ scope.row.adminRemark }}
          </template>
        </el-table-column>
        <el-table-column
          :label="langType ? '操作' : 'Operation'"
          fixed="right"
          width="69"
          prop="size"
        >
          <template slot-scope="scope">
            <div class="operate">
              <span
                class="link"
                @click="showAccept(scope.row)"
                v-if="['03'].includes(scope.row.orderStatus) && !scope.row.hang"
              >
                {{ langType ? "接单" : "Order" }}
              </span>
              <span
                class="link"
                @click="handleShowSendOrder(scope.row)"
                v-if="['04'].includes(scope.row.orderStatus) && !scope.row.hang"
              >
                {{ langType ? "发货" : "Ship" }}
              </span>
              <span
                class="link"
                @click="handleHang(scope.row.appId, '01')"
                v-if="!scope.row.hang && activeName != 'hanging'"
              >
                {{ langType ? "挂起" : "Hang" }}
              </span>
              <span
                class="link"
                @click="handleHang(scope.row.appId, '02')"
                v-if="
                  scope.row.hang &&
                  (activeName == 'sum' || activeName == 'hanging')
                "
              >
                {{ langType ? "取消挂起" : "Unhang" }}
              </span>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <pagination
        class="pagination"
        :total="total"
        :page.sync="form.pageNum"
        :limit.sync="form.pageSize"
        @pagination="getData"
      />
    </div>

    <ExpreDetail
      @onClose="handleCloseExpre"
      :detail="expreDetail"
      :visible="expreVisible"
    ></ExpreDetail>

    <!-- 编辑订单弹窗 -->
    <EditOrder
      v-if="currentOrder && currentOrder.order"
      :canEdit="orderCanEdit"
      :appId="currentAppId"
      :visible="showEdit"
      :orderDetail="currentOrder"
      @onClose="hideEdit"
      @onUpdate="onUpdateFinish"
    />

    <!-- 同步订单弹窗 -->
    <SyncOrder
      :platNo="`03`"
      :visible="showSyncOrder"
      @onClose="hideSyncOrder"
      @update="getData"
    />

    <!-- 汇率设置弹窗 -->
    <ExchangeDialog
      :visible="showExchange"
      @onClose="hideExchange"
      @onOk="okEditExchange"
    />

    <!-- 取消订单设置弹窗 -->
    <CancelDialog
      :orderData="currentOrder"
      :visible="showCancel"
      @onClose="hideCancel"
      @onOk="okEditCancel"
    />

    <!-- 手续费设置弹窗 -->
    <ServiceDialog
      :visible="showService"
      @onClose="hideService"
      @onOk="okEditService"
    />
    <!-- 发货时间设置弹窗 -->
    <sendDialog
      :orderData="currentOrder"
      :visible="showSendTime"
      @onClose="hideSendTime"
      @onOk="okEditSendTime"
    />

    <!-- 备注弹窗 -->
    <RemarkDialog :visible="showRemark" @onClose="hideRemark" />

    <!-- 复制弹窗 -->
    <CopyOrder
      v-if="currentOrder.order"
      :visible="showCopy"
      @onClose="hideCopy"
      :orderData="currentOrder"
      @onOk="okCopyOrder"
    />

    <!-- 销售设置弹窗 -->
    <EditSale
      :visible="showEditSale"
      @onClose="hideEditSale"
      :orderData="currentOrder"
      @onOk="okEditSale"
    />

    <!-- 订单审核弹窗 -->
    <AuditOrder
      :visible="showAuditOrder"
      @onClose="hideAuditOrder"
      :orderData="currentOrder"
      @onOk="okAuditOrder"
    />

    <!-- 订单审核弹窗 -->
    <AcceptOrder
      :visible="showAcceptOrder"
      @onClose="hideAcceptOrder"
      :orderData="currentOrder"
      @onOk="okAcceptOrder"
    />

    <!-- 选择快递弹窗 -->
    <SelectShip
      :orderData="currentOrder"
      :visible="showShip"
      @onClose="hideShip"
    />

    <!-- 订单审核弹窗 -->
    <LabelDialog
      :visible="showLabel"
      @onClose="hideLabelDialog"
      :remarkIds="remarkIds"
      :orderRemark="orderRemark"
      @onOk="okLabelDialog"
    />

    <!-- 发货弹窗 -->
    <SendOrderFlb
      :appIds="appIds"
      :appNos="appNos"
      :orderData="currentOrder"
      :visible="showSendOrder"
      :langType="langType"
      @onClose="hideSendOrder"
    />
    <el-dialog
      title="产品列表"
      :visible.sync="detailVisible"
      width="60%"
      :before-close="handleCloseDetail"
    >
      <el-table :data="productList" class="exchange-table">
        <el-table-column prop="shippingMethodName" label="主题名称">
          <template slot-scope="scope">
            <a style="cursor: pointer" @click="handleOpenProduct(scope.row)">{{
              scope.row.proName
            }}</a>
          </template>
        </el-table-column>
        <el-table-column prop="color" label="颜色"> </el-table-column>
        <el-table-column prop="size" label="尺码"> </el-table-column>
        <el-table-column prop="quantity" label="数量"> </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="handleCloseDetail"
          >关 闭</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
      :close-on-click-modal="false"
      :title="`上传面单`"
      :visible.sync="showUploadLabel"
      width="540px"
      class="remarkDialog"
    >
      <el-form
        :rules="rules"
        :model="importForm"
        ref="importForm"
        label-width="120px"
      >
        <el-form-item prop="file" label="选择文件：">
          <input
            type="file"
            name="file"
            class="webuploader"
            accept=""
            @change="uploadFn"
            ref="inputer"
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showUploadLabel = false" size="small"
          >返回</el-button
        >
        <el-button type="primary" @click="handleUploadLabel" size="small">
          保存
        </el-button>
      </span>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      :title="dialogTitle"
      :visible.sync="previewImagesVisible"
      width="800px"
    >
      <div class="preview-area">
        <div class="carousel">
          <el-carousel
            ref="carouselPreview"
            style="height: 500px; overflow: hidden"
            :autoplay="false"
            :interval="5000"
            arrow="always"
          >
            <el-carousel-item
              style="height: 500px"
              v-for="(productImage, index) in productImageList"
              :key="index"
            >
              <img :src="productImage" />
            </el-carousel-item>
          </el-carousel>
          <div v-if="false" class="color-picker">
            <ul class="color-picker-list">
              <li
                @click="handlePickColor(record)"
                v-for="record of colorList"
                :key="record"
                :class="{ cur: currentColor === record }"
              >
                <a :style="{ backgroundColor: dictMap['color'][record] }"></a>
              </li>
            </ul>
          </div>
        </div>

        <div class="preview-list">
          <div
            v-for="(productImage, index) in productImageList"
            :key="index"
            class="preview-list-item"
            :class="{ 'is-active': activeCarousel === index }"
            @click="handleClickPreviewImage(index)"
          >
            <img :src="productImage" />
            <div class="preview-text">效果图{{ index + 1 }}</div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Breadcrumb from "@/components/common/Breadcrumb";
import LoanTip from "./components/LoanTip";
import EditOrder from "./components/EditOrder";
import SyncOrder from "./components/SyncOrder";
import ExchangeDialog from "./components/ExchangeDialog";
import ServiceDialog from "./components/ServiceDialog";
import sendDialog from "./components/SetSendTime";
import RemarkDialog from "./components/RemarkDialog";
import EditSale from "./components/EditSale";
import CopyOrder from "./components/CopyOrder";
import AuditOrder from "./components/AuditOrder";
import AcceptOrder from "./components/AcceptOrder";
import SendOrderFlb from "./components/SendOrderFlb";
import CancelDialog from "./components/CancelOrder";
import { selectExpreList, getExpreProcess, getOrderCnt, freshByAppNo } from "@/api/order/all";
import { mapGetters } from "vuex";
import dayjs from "dayjs";
import LabelDialog from "./components/LabelDialog";

import {
  orderList,
  getOrderDetail,
  cancelOrder,
  recoveryOrder,
  orderToCopy,
  createShip,
  exportExcel,
  uploadTb,
  getDesignInfo,
  handSetOrder,
  batchSendPhByHand,
  setAdminRemark
} from "@/api/order/all";

import { getShipMethod } from "@/api/product/shipMethod";

import { getShopList } from "@/api/system/shopManage";
import noImage from "@/assets/images/no_image.png";
import SelectShip from "./components/SelectShip";
import qs from "qs";
import { downLoadExcel } from "@/utils/zipdownload";
import ExpreDetail from "./components/ExpreDetail";
import { listSubAccount } from "@/api/system/user";
import { listUser } from "@/api/business/merchantManage";
import JSZip from "jszip";
import axios from "axios";
import getMinImageByObject from "@/utils/autoClip";
export default {
  name: "order",
  components: {
    Breadcrumb,
    SyncOrder,
    LoanTip,
    ExchangeDialog,
    ServiceDialog,
    sendDialog,
    EditOrder,
    RemarkDialog,
    CopyOrder,
    EditSale,
    AuditOrder,
    SelectShip,
    SendOrderFlb,
    ExpreDetail,
    CancelDialog,
    AcceptOrder,
    LabelDialog,
  },
  data() {
    return {
      trackingCodeCount:0,
      appNosCount:0,
      isCheckAllThirdStatus:{
        tiktok:false,
        shopee:false,
        lazada:false
      },
      thirdOrderStatus: {
        tiktok: [],
        shopee: [],
        lazada: []
      },
      isCheckAmazonStatus: false,
      shopList: [],
      shopListClone: [],
      noImage: noImage,
      form: {
        platNo: [], // 平台渠道
        amazonSite: "", // 来源国家
        productType: "", // 产品类型
        matchType: "", // 匹配类型
        orderSource: "", // 订单来源
        createTime: [], // 创建时间
        lineTime: [], // 支付时间
        sendTime: [], // 发货时间
        orderTime:[], // 下单时间
        shopId: [], // 店铺名称
        appNos: "", // 订单编号
        trackingNumber: "", // 物流单号
        orderStatus: [], // 订单状态
        pOperNo: [], //商家账号
        shippingMethod: "", //物流方式
        itemSku: "",
        pageNum: 1,
        pageSize: 30,
        operNos: [],
        manufacturer: [],
        sortType: "f",
        sortBy: "desc",
        requestType: "01",
        orderRemarkColor: [],
        amazonOrderStatus: [],
        orderRemarkType: [],
        state: [],
        downloadFlag: "",
        productId: "",
        appNoDels: "",
        noMerchant:"",
        trackingCode: "",
        adminRemark: "",
      },
      textColorList: [
        {
          hex: "#171717",
          name: "black",
        },
        {
          hex: "#00FFFF",
          name: "cyan",
        },
        {
          hex: "#a1a1a1",
          name: "grey",
        },
        {
          hex: "#9c6a23",
          name: "brown",
        },
        {
          hex: "#d82424",
          name: "red",
        },
        {
          hex: "#ee6419",
          name: "orange",
        },
        {
          hex: "#50b03c",
          name: "green",
        },
        {
          hex: "#035239",
          name: "darkGreen",
        },
        {
          hex: "#192c7c",
          name: "blue",
        },
        {
          hex: "#3f92db",
          name: "sky",
        },
        {
          hex: "#934b7c",
          name: "purple",
        },
        {
          hex: "#ffde00",
          name: "yellow",
        },
      ],
      showAppNosTextarea: false,
      rules: {
        file: [{ required: true, message: "请选择文件", trigger: "change" }],
      },
      previewImagesVisible: false,
      productImageList: [],
      importForm: {
        appId: "",
        file: null,
      },

      isExpand: false,
      manufacturer: "",
      isCheckManufacturer: false,

      activeCarousel: 0,
      showUploadLabel: false,
      cancelOrderVisible: false, //取消订单弹框
      modalTitle: "",
      modalText: "",
      statusText: "",
      statusMap: null,
      total: 0,
      tableData: [], // 表格数据
      multipleSelection: [], // 选中列表数据
      showSyncOrder: false,
      showService: false,
      showExchange: false,
      showCancel: false,
      showEdit: false,
      showRemark: false,
      showShip: false,
      showCopy: false,
      showSendOrder: false,
      showEditSale: false,
      showAuditOrder: false,
      showAcceptOrder: false,
      currentOrder: {},
      currentAppId: "",
      orderCanEdit: true,
      roles: [],
      shipList: [],
      isCheckShop: true,
      isCheckStatus: true,
      scrollMenu: null,
      objectHeight: null,
      expreList: [],
      expreDetail: {},
      expreVisible: false,
      shopName: "",
      nickName: "",
      isCheckUser: true,
      userList: [],
      activeName: "sum",
      accountList: [],
      detailVisible: false,
      showSendTime: false,
      productList: [],
      dialogTitle: "效果图",
      remarkIds: "",
      orderRemark: {},
      showLabel: false,
      langType: true,
      screenType: false,
      orderCount: {},
      appIds: "",
      appNos: "",
      showAppNosTextareaDel: false,
      showMerchantTextareaDel: false,
      showTrackingCodeTextareaDel: false,
      appNoDels: false,
      noMerchant:false,
      trackingCode: false,
      batchRemark:"",//批量备注
    };
  },
  computed: {
    ...mapGetters(["dictData", "dictMap", "user"]),
    rowSelectNum() {
      let rows = [];
      for (let record of this.multipleSelection) {
        if (!rows.includes(record.appNo)) {
          rows.push(record.appNo);
        }
      }
      return rows.length;
    },
    showPayButton() {
      let permission = JSON.stringify(this.$store.state.permission);
      return permission.indexOf("GetPay") !== -1;
    },
    orderWidth() {
      let width = document.body.clientWidth;
      let orderWidth = "476";
      if (width > 1500) {
        orderWidth = "476";
      } else {
        orderWidth = "339";
      }
      return orderWidth;
    },
    tdWidth() {
      let width = document.body.clientWidth;
      let orderWidth = "200";
      if (width > 1400) {
        orderWidth = "189";
      } else {
        orderWidth = "129";
      }
      return orderWidth;
    },
    routeName() {
      return this.$route.path;
    },
    currentPathName() {
      const { routeName } = this;
      if (routeName.includes("lazada")) {
        return "lazada";
      }
      if (routeName.includes("shopee")) {
        return "shopee";
      }
      if (routeName.includes("tiktok")) {
        return "tiktok";
      }
      if (routeName.includes("orderFlb")) {
        return "orderFlb";
      }
      return false
    },
    allThirdStatus() {
      if (this.dictData["lazada_status"]) {
        return [
          {
            name: "lazada",
            data: this.dictData["lazada_status"],
          },
          {
            name: "shopee",
            data: this.dictData["shopee_status"],
          },
          {
            name: "tiktok",
            data: this.dictData["tiktok_status"],
          }
        ]
      }

    }
  },
  async mounted() {
    let appNo = this.$route.query.appNo;
    if (appNo) {
      this.form.appNos = appNo;
      this.form.createTime = [];
    }
    let status = this.$route.query.status;
    if (status) {
      this.activeName = status;
    }

    let langType = localStorage.getItem("langType");
    if (langType) {
      this.langType = langType == "1" ? true : false;
    }

    window.setInterval(() => {
      let screenType = localStorage.getItem("screenType");
      if (screenType) {
        this.screenType = screenType == "1" ? true : false;
        this.handleChangeScreenType();
      }
    }, 1000);

    window.setInterval(() => {
      this.getOrderCnt();
    }, 1000 * 60);

    this.getShops();
    this.getShip();
    this.getUserList();
    this.getAccountList();
    this.roles = this.user.roles;

    // this.dictData["order_status"].map((record) => {
    //   this.form.orderStatus.push(record.value)
    // })
  },
  watch: {
    "form.appNos": {
      handler(val) {
       if (!!val) {
        if (!val.includes(',')) {
         return  this.appNosCount = 1
        }
        const count = val.split(',').filter(item => !!item).length
        this.appNosCount = count
       }else{
        this.appNosCount = 0
       }
       
      },
      immediate: true,
    },
    "form.trackingCode": {
      handler(val) {
       if (!!val) {
        if (!val.includes(',')) {
         return  this.trackingCodeCount = 1
        }
        const count = val.split(',').filter(item => !!item).length
        this.trackingCodeCount = count
       }else{
        this.trackingCodeCount = 0
       }
       
      },
      immediate: true,
    },
    // trackingCode:function(val){
    //   console.log(val);
    //    if (!!val) {
    //     if (!val.includes('/n')) {
    //      return  this.trackingCodeCount = 1
    //     }
    //     const count = val.split(',').filter(item => !!item).length
    //     this.trackingCodeCount = count
    //    }else{
    //     this.trackingCodeCount = 0
    //    }
    // },
    routeName: {
      handler() {
        this.getCache();
        // 标记：特殊字段清理缓存
        this.form.noMerchant = ""
        this.noMerchant = false
        this.form.trackingCode = ""
        this.trackingCode = false
        this.form.pOperNo = []
        // end
        this.getData();

      },
      immediate: true,
    },
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleChangeAllThirdStatus(name) {
      this.thirdOrderStatus[name] = [];
      if (this.isCheckAllThirdStatus[name]) {
        this.dictData[name + "_status"].map((record) => {
          this.thirdOrderStatus[name].push(record.value);
        });
      }
    },
    handleChangeAmazonStatus() {
      this.form.amazonOrderStatus = [];
      if (this.isCheckAmazonStatus) {
        this.dictData[this.currentPathName + "_status"].map((record) => {
          this.form.amazonOrderStatus.push(record.value);
        });
      }
    },

    async getOrderCnt() {
      let params = Object.assign({}, this.form);

      if (this.form.createTime && this.form.createTime.length > 0) {
        params["beginTime"] = dayjs(this.form.createTime[0]).format(
          "YYYY-MM-DD"
        );
        params["endTime"] = dayjs(this.form.createTime[1]).format("YYYY-MM-DD");
      }

      if (this.form.lineTime && this.form.lineTime.length > 0) {
        params["lineTimeBegin"] = dayjs(this.form.lineTime[0]).format(
          "YYYY-MM-DD"
        );
        params["lineTimeEnd"] = dayjs(this.form.lineTime[1]).format(
          "YYYY-MM-DD"
        );
      }

      if (this.form.sendTime && this.form.sendTime.length > 0) {
        params["sendTimeBegin"] = dayjs(this.form.sendTime[0]).format(
          "YYYY-MM-DD"
        );
        params["sendTimeEnd"] = dayjs(this.form.sendTime[1]).format(
          "YYYY-MM-DD"
        );
      }
      if (this.form.orderTime && this.form.orderTime.length > 0) {
        params["orderTimeBegin"] = dayjs(this.form.orderTime[0]).format(
          "YYYY-MM-DD"
        )
        params["orderTimeEnd"] = dayjs(this.form.orderTime[1]).format(
          "YYYY-MM-DD"
        )
      }
      params.shopIds = params.shopId.join(",");
      params.amazonOrderStatusList = params.amazonOrderStatus.join(",")
      delete params.amazonOrderStatus;
      if (this.currentPathName == "orderFlb") {
        const { tiktok, shopee, lazada } = this.thirdOrderStatus;
        params.amazonOrderStatusList = tiktok.concat(shopee, lazada).join(",");
      }
      params.orderStatus = params.orderStatus.join(",");
      params.operNos = params.operNos.join(",");
      params.appNos = params.appNos.replace("，", ",");
      params.platNos = params.platNo.join(",");
      params.pOperNo = params.pOperNo.join("--");
      params.orderRemarkType = params.orderRemarkType.join(",");
      params.orderRemarkColor = params.orderRemarkColor.join(",");
      params.manufacturer = params.manufacturer.join(",");
      params.state = params.state.join(",");

      let path = this.$route.path;

      if (path.indexOf("lazada") > -1) {
        params.platNos = "03";
      }

      if (path.indexOf("shopee") > -1) {
        params.platNos = "05";
      }

      if (path.indexOf("tiktok") > -1) {
        params.platNos = "10";
      }

      if (path.indexOf("jst") > -1) {
        params.productType = "02";
      } else {
        params.productType = "01";
      }

      if (params.shopIds == "" && this.isCheckShop) {
        let shopId = [];
        for (let record of this.shopList) {
          shopId.push(record.shopId);
        }
        params.shopIds = shopId.join(",");
      }
      if (this.user.userType == "00") {
        delete params["shopIds"];
      }

      delete params["operNos"];
      delete params["platNo"];
      params.hang = undefined;

      if (this.activeName == "notpay") {
        params.orderStatus = "01";
      }

      if (this.activeName == "pay") {
        params.orderStatus = "02";
      }

      if (this.activeName == "produce") {
        params.orderStatus = "03";
      }
      if (this.activeName == "producing") {
        params.orderStatus = "04";
        // params["beginTime"] = undefined
        // params["endTime"] = undefined
      }
      if (this.activeName == "canceled") {
        params.orderStatus = "06";
      }

      if (this.activeName == "sended") {
        params.orderStatus = "05";
        let curDate = new Date();
        let preDate = new Date(curDate.getTime() - 24 * 60 * 60 * 1000 * 7);
        params["beginTime"] = undefined;
        params["endTime"] = undefined;
        // params["lineTimeEnd"] = this.parseTime(
        //   preDate,
        //   "{y}-{m}-{d} {h}:{i}:{s}"
        // )
      }

      if (this.activeName == "hanging") {
        params.hang = "01";
        params.orderStatus = "";
      }

      if (this.activeName == "other") {
        params.orderStatus = "03,04,05,06,07,09";
      }

      if (this.activeName == "sum") {
        params.orderStatus = "03,04,05";
      }

      delete params["createTime"];
      delete params["lineTime"];
      delete params["sendTime"];
      delete params["shopId"];
      delete params["orderTime"];
      let result = await getOrderCnt(params);
      this.orderCount = result.data;
    },
    handleShowMaps(row) {
      this.productImageList = [];
      for (let record of row.maps) {
        this.productImageList.push(record.picUrl);
      }
      this.dialogTitle = "图片预览";
      this.activeCarousel = 0;
      this.previewImagesVisible = true;
      this.$refs["carouselPreview"].setActiveItem(0)
    },
    handleShowSkuPics(row) {
      this.productImageList = [];
      for (let record of row.sOrderSkuPrintPic) {
        this.productImageList.push(record.picUrl);
      }
      this.dialogTitle = "打印图";
      this.activeCarousel = 0;
      this.previewImagesVisible = true;
      this.$refs["carouselPreview"].setActiveItem(0)
    },
    handleShowFactoryPics(row) {
      this.productImageList = []
      for (let record of row.sOrderSkuFactoryPic) {
        this.productImageList.push(record.picUrl)
      }
      this.dialogTitle = "工厂图"
      this.activeCarousel = 0
      this.previewImagesVisible = true
      this.$refs["carouselPreview"].setActiveItem(0)
    },
    async handleShowDesignMaps(row) {
      let path = this.$route.path;

      if (path.indexOf("jst") == -1) {
        this.productImageList = [];
        let colorList = {};
        let result = await getDesignInfo(row.designId);
        for (let record of result.data.skuList) {
          let color = record.properVal.split(":")[0];
          if (colorList[color]) {
            continue;
          } else {
            colorList[color] = "1";
          }
          for (let pic of record.picList) {
            if (record.properVal.indexOf(row.color) > -1) {
              this.productImageList.push(pic.picUrl);
            }
          }
        }
      } else {
        this.productImageList = [row.picUrl];
      }

      this.dialogTitle = "效果图预览";
      this.previewImagesVisible = true;
    },
   async getAccountList(query) {
      let pageSize = 10
      if (!query) {
        query = ""
      } else {
        pageSize = 1000
      }
      let result = await listUser({
        pageNum: 1,
        pageSize: pageSize,
        userType: "01",
        userName: query,
      })
      this.accountList = result.rows
    },
    handleClickTab() {},
    handleCloseExpre() {
      this.expreVisible = false;
    },
    async handleShowExpre(detail, row) {
      this.expreVisible = true
      detail.appNo = row.appNo
      detail.appId = row.appId
      if (row.trackingNumber) {
        detail.trackingNumber = row.trackingNumber
      }
      this.expreDetail = detail
    },
    getShops() {
      getShopList().then((res) => {
        this.shopList = res.rows;
        this.shopListClone = this._.clone(res.rows);
        this.$nextTick(() => {
          this.scrollMenu = document.querySelector(".table-menu");
          this.objectHeight = this.scrollMenu.offsetTop;
          window.addEventListener(
            "scroll",
            this.throttle(this.handleScroll, 100)
          );
        });
        // this.handleChangeShop()
        // res.rows.map(()=>{})
      });
    },
    handleChangeManufacturer() {
      this.form.manufacturer = [];
      if (this.isCheckManufacturer) {
        this.dictData["MANUFACTURER"].map((record) => {
          this.form.manufacturer.push(record.value);
        });
      }
    },
    handleChangeStatus() {
      this.form.orderStatus = [];
      if (this.isCheckStatus) {
        this.dictData["order_status"].map((record) => {
          this.form.orderStatus.push(record.value);
        });
      }
    },
    getShip() {
      getShipMethod().then((res) => {
        this.shipList = res.rows;
      });
    },
    getUserList() {
      listSubAccount({}).then((res) => {
        res.rows.unshift({
          userName: this.user.name,
          nickName: this.user.nickName ? this.user.nickName : this.user.name,
        });
        this.userList = res.rows;
      });
    },
    handleChangeUser() {
      this.form.operNos = [];
      let shopList = this._.clone(this.shopListClone);
      if (this.isCheckUser) {
        this.userList.map((record) => {
          this.form.operNos.push(record.userName);
        });
        this.shopList = shopList;
      } else {
        this.shopList = shopList.filter((shop) => {
          for (let record of this.form.operNos) {
            if (record == shop.operNo) {
              return true;
            }
          }
          return false;
        });
      }
      this.form.shopId = [];
    },

    getProducingDay(date) {
      return (
        Math.floor(((new Date() - new Date(date)) / 1000 / 60 / 60 / 24) * 10) /
        10
      );
    },
    handleChangeOper() {
      let shopList = this._.clone(this.shopListClone);
      this.shopList = shopList.filter((shop) => {
        if (this.form.operNos.includes(this.user.name)) {
          return true;
        }
        for (let record of this.userList) {
          if (this.form.operNos.includes(record.userName)) {
            for (let item of record.shops) {
              if (item.shopId == shop.shopId) {
                return true;
              }
            }
          }
        }
        return false;
      });

      this.form.shopId = [];
      if (this.form.operNos.length == 0 && this.isCheckUser) {
        this.shopList = this._.clone(this.shopListClone);
      }
    },
    // 搜索
    getData() {
      this.setCache();
      let params = Object.assign({}, this.form);

      if (this.form.createTime && this.form.createTime.length > 0) {
        params["beginTime"] = dayjs(this.form.createTime[0]).format(
          "YYYY-MM-DD"
        );
        params["endTime"] = dayjs(this.form.createTime[1]).format("YYYY-MM-DD");
      }

      if (this.form.lineTime && this.form.lineTime.length > 0) {
        params["lineTimeBegin"] = dayjs(this.form.lineTime[0]).format(
          "YYYY-MM-DD"
        );
        params["lineTimeEnd"] = dayjs(this.form.lineTime[1]).format(
          "YYYY-MM-DD"
        );
      }

      if (this.form.sendTime && this.form.sendTime.length > 0) {
        params["sendTimeBegin"] = dayjs(this.form.sendTime[0]).format(
          "YYYY-MM-DD"
        );
        params["sendTimeEnd"] = dayjs(this.form.sendTime[1]).format(
          "YYYY-MM-DD"
        );
      }
      if (this.form.orderTime && this.form.orderTime.length > 0) {
        params["orderTimeBegin"] = dayjs(this.form.orderTime[0]).format(
          "YYYY-MM-DD"
        )
        params["orderTimeEnd"] = dayjs(this.form.orderTime[1]).format(
          "YYYY-MM-DD"
        )
      }
      params.shopIds = params.shopId.join(",");
      params.orderStatus = params.orderStatus.join(",");
      params.operNos = params.operNos.join(",");
      params.appNos = params.appNos.replace("，", ",");
      params.platNos = params.platNo.join(",");
      params.orderRemarkType = params.orderRemarkType.join(",");
      params.orderRemarkColor = params.orderRemarkColor.join(",");
      params.manufacturer = params.manufacturer.join(",");

      params.state = params.state.join(",");

      params.pOperNo = params.pOperNo.join("--");
      params.amazonOrderStatusList = params.amazonOrderStatus.join(",")

      delete params.amazonOrderStatus;
      if (this.currentPathName == "orderFlb") {
        const { tiktok, shopee, lazada } = this.thirdOrderStatus;
        params.amazonOrderStatusList = tiktok.concat(shopee, lazada).join(",");
      }
      let path = this.$route.path;

      if (path.indexOf("lazada") > -1) {
        params.platNos = "03";
      }

      if (path.indexOf("shopee") > -1) {
        params.platNos = "05";
      }

      if (path.indexOf("tiktok") > -1) {
        params.platNos = "10";
      }

      if (path.indexOf("jst") > -1) {
        params.productType = "02";
      } else {
        params.productType = "01";
      }

      if (params.shopIds == "" && this.isCheckShop) {
        let shopId = [];
        for (let record of this.shopList) {
          shopId.push(record.shopId);
        }
        params.shopIds = shopId.join(",");
      }
      if (this.user.userType == "00") {
        params.from = "02";
        delete params["shopIds"];
      }

      delete params["operNos"];
      delete params["platNo"];
      params.hang = undefined;

      if (this.activeName == "notpay") {
        params.orderStatus = "01";
      }

      if (this.activeName == "pay") {
        params.orderStatus = "02";
      }

      if (this.activeName == "produce") {
        params.orderStatus = "03";
      }
      if (this.activeName == "producing") {
        params.orderStatus = "04";
        // params["beginTime"] = undefined
        // params["endTime"] = undefined
      }
      if (this.activeName == "canceled") {
        params.orderStatus = "06";
      }

      if (this.activeName == "sended") {
        params.orderStatus = "05";
        let curDate = new Date();
        let preDate = new Date(curDate.getTime() - 24 * 60 * 60 * 1000 * 7);
        params["beginTime"] = undefined;
        params["endTime"] = undefined;
        // params["lineTimeEnd"] = this.parseTime(
        //   preDate,
        //   "{y}-{m}-{d} {h}:{i}:{s}"
        // )
      }

      if (this.activeName == "hanging") {
        params.hang = "01";
        params.orderStatus = "";
      }

      if (this.activeName == "other") {
        params.orderStatus = "03,04,05,06,07,09";
      }

      if (this.activeName == "sum") {
        params.orderStatus = "03,04,05";
      }

      delete params["createTime"];
      delete params["lineTime"];
      delete params["sendTime"];
      delete params["shopId"];
      delete params["orderTime"];
      this.startLoading();
      this.getOrderCnt();

      orderList(params)
        .then((res) => {
          if (res.code !== 200) {
            this.$message.error("获取订单列表失败");
          } else {
            this.total = res.total;
            let array = [];
            for (let record of res.rows) {
              let isNew = true;
              for (let sku of record.skuList) {
                let data = JSON.parse(JSON.stringify(record));
                if (sku.properVal) {
                  data.color = sku.properVal.split(":")[0];
                  data.size = sku.properVal.split(":")[1];
                }
                data.hintColor = this.getHourColor(
                  sku.slaTimeStamp,
                  sku.receiveTime
                );
                data.proName = sku.proName;
                data.count = record.skuList.length;
                data.picUrl = sku.picUrl;
                data.slaTimeStamp = sku.slaTimeStamp;
                // data.sOrderSkuPic = sku.sOrderSkuPic;
                data.sOrderSkuPrintPic = sku.sOrderSkuPic?.filter(v => v.picType == '01') || []
                data.sOrderSkuFactoryPic = sku.sOrderSkuPic?.filter(v => v.picType == '02') || []
                data.promisedShippingTime = sku.promisedShippingTime;
                data.receiveTime = sku.receiveTime;
                data.amazonOrderStatus = sku.amazonOrderStatus;
                if (data.platNo == "03") {
                  data.amazonOrderStatus = sku.amazonOrderStatus
                    ? this.dictMap["lazada_status"][sku.amazonOrderStatus]
                    : "-";
                }
                if (data.platNo == "05") {
                  data.amazonOrderStatus = sku.amazonOrderStatus
                    ? this.dictMap["shopee_status"][sku.amazonOrderStatus]
                    : "-";
                }
                if (data.platNo == "10") {
                  data.amazonOrderStatus = sku.amazonOrderStatus
                    ? this.dictMap["tiktok_status"][sku.amazonOrderStatus]
                    : "-";
                }
                data.payMethod = sku.payMethod;
                data.designId = sku.designId;
                data.num = sku.num;
                data.trackingCode = sku.trackingCode;
                data.proCode = sku.proCode;
                data.state = sku.product?.state;
                if (isNew) {
                  data.isNew = isNew;
                }
                isNew = false;
                data.manufacturer = sku.manufacturer;
                data.ifNewDesign = sku.ifNewDesign;
                array.push(data);
              }
            }
            this.tableData = array;
            this.$nextTick(() => {
              this.handleChangeLangType();
            });
          }
          this.endLoading();
        })
        .catch(() => {
          this.endLoading();
        });
    },
    handleSelectShip(row) {
      this.currentOrder = row;
      this.showShip = true;
    },
    // 重置
    reset() {
      // this.$refs['form'].resetFields();
      // return
      this.form = {
        platNo: [], // 平台渠道
        amazonSite: "", // 来源国家
        productType: "", // 产品类型
        matchType: "", // 匹配类型
        orderSource: "", // 订单来源
        createTime: [], // 创建时间
        lineTime: [], // 支付时间
        sendTime: [], // 发货时间
        orderTime:[], // 订单时间
        shopId: [], // 店铺名称
        appNos: "", // 订单编号
        trackingNumber: "", // 物流单号
        orderStatus: [], // 订单状态
        pOperNo: [], //商家账号
        shippingMethod: "", //物流方式
        itemSku: "",
        pageNum: 1,
        pageSize: 30,
        operNos: [],
        manufacturer: [],
        sortType: "f",
        sortBy: "desc",
        requestType: "01",
        orderRemarkColor: [],
        orderRemarkType: [],
        state: [],
        amazonOrderStatus: [],
      };
    },
    copyText(text) {
      let target = document.createElement("input"); //创建input节点
      target.value = text; // 给input的value赋值
      document.body.appendChild(target);
      target.value = text; // 修改文本框的内容
      target.select(); // 选中文本
      document.execCommand("copy"); // 执行浏览器复制命令
      this.msgSuccess("复制成功");
      document.body.removeChild(target);
    },
    // 列表选择
    handleSelectionChange(val) {
      let array = [];
      let removeIds = [];
      for (let record of val) {
        if (record.skuList.length > 1) {
          let count = 0;
          for (let item of val) {
            if (item.appNo == record.appNo) {
              count++;
            }
          }
          if (count < record.skuList.length) {
            removeIds.push(record.appNo);
          }
        }
      }
      for (let record of val) {
        if (removeIds.includes(record.appNo)) {
          continue;
        }
        array.push(record);
      }
      for (let record of removeIds) {
        for (let data of val) {
          if (data.appNo == record) {
            array.push(data);
            break;
          }
        }
      }

      this.multipleSelection = array;
    },
    GetOrderStatus(orderStatus) {
      orderStatus = this.dictMap["order_status"][orderStatus];
      if (this.langType) {
        if (orderStatus == "排单中") {
          return "待接单";
        }
      } else {
        if (orderStatus == "待付货款") {
          return "wait pay";
        }
        if (orderStatus == "已付货款") {
          return "payed";
        }
        if (orderStatus == "排单中") {
          return "wait order";
        }
        if (orderStatus == "生产中") {
          return "producing";
        }
        if (orderStatus == "已发货") {
          return "shipped";
        }
        if (orderStatus == "已取消") {
          return "canceled";
        }
        if (orderStatus == "审核不通过") {
          return "audit failed";
        }
        if (orderStatus == "待编辑") {
          return "edit";
        }
      }

      return orderStatus;
    },
    handleBatchLabel() {
      let ids = [];
      this.multipleSelection.map((el) => {
        ids.push(el.appId);
      });
      if (ids.length == 0) {
        this.msgError("请选择订单");
        return;
      }
      this.remarkIds = ids.join(",");
      this.orderRemark = {};
      this.showLabel = true;
    },
    hideLabelDialog() {
      this.showLabel = false;
    },
    remark() {
      this.showRemark = true;
    },
    okLabelDialog() {
      this.getData();
      this.showLabel = false;
    },
    hideRemark() {
      this.showRemark = false;
    },
    showLabelDialog(row) {
      this.remarkIds = row.appId;
      if (row.sOrderRemark && row.sOrderRemark.length > 0) {
        this.orderRemark = row.sOrderRemark[0];
      }
      this.showLabel = true;
    },
    handleAppNosBlurDel() {
      this.form.appNoDels = this.appNoDels.replace(/\n/g, ",");
      this.showAppNosTextareaDel = false;
    },
    handleShowAppsNosDel() {
      this.appNoDels = this.form.appNoDels.replace(/,/g, "\n");
      this.showAppNosTextareaDel = true;
    },
    handleMerchantBlurDel() {
      this.form.noMerchant = this.noMerchant.replace(/\n/g, ",");
      this.showMerchantTextareaDel = false;
    },
    handleShowMerchantsNosDel() {
      this.noMerchant = this.form.noMerchant.replace(/,/g, "\n");
      this.showMerchantTextareaDel = true;
    },
     handleTrackingCodeBlurDel() {
      this.form.trackingCode = this.trackingCode.replace(/\n/g, ",");
      this.showTrackingCodeTextareaDel = false;
    },
    handleShowTrackingCodeNosDel() {
      this.trackingCode = this.form.trackingCode.replace(/,/g, "\n");
      this.showTrackingCodeTextareaDel = true;
    },
    syncOrder() {
      this.showSyncOrder = true;
    },
    hideSyncOrder() {
      this.showSyncOrder = false;
    },
    exchange() {
      this.showExchange = true;
    },
    hideExchange() {
      this.showExchange = false;
    },
    hideCancel() {
      this.showCancel = false;
    },
    okEditExchange() {
      this.getData();
      this.showExchange = false;
    },
    okEditCancel() {
      this.getData();
      this.showCancel = false;
    },
    service() {
      this.showService = true;
    },
    hideService() {
      this.showService = false;
    },
    showAudit(data) {
      this.currentOrder = data;
      this.showAuditOrder = true;
    },
    showAccept(data) {
      this.currentOrder = data;
      this.showAcceptOrder = true;
    },
    handleShowSendOrder(data) {
      this.currentOrder = data;
      this.showSendOrder = true;
    },
    hideAuditOrder() {
      this.showAuditOrder = false;
    },
    hideAcceptOrder() {
      this.showAcceptOrder = false;
    },
    okEditService() {
      this.getData();
      this.showService = false;
    },
    hideSendTime() {
      this.showSendTime = false;
    },
    okEditSendTime() {
      this.getData();
      this.showSendTime = false;
    },
    handleShowSendTime(data) {
      this.currentOrder = data;
      this.showSendTime = true;
      let a = 1;
    },
    showOrderDetail(data) {
      getOrderDetail(data.appId).then((res) => {
        if (!res.data.addr) {
          res.data.addr = {};
        }
        this.currentOrder = res.data;
        this.currentAppId = data.appId;
        this.showEdit = true;
        this.orderCanEdit = false;
      });
    },
    handleCommand(command) {
      if (command == "exchange") {
        this.showExchange = true;
      } else if (command == "service") {
        this.showService = true;
      }
    },
    async handleHang(appId, status) {
      let hint = `确定${status == "01" ? "挂起" : "取消挂起"}吗`;
      if (!this.langType) {
        hint = `Are you sure to ${status == "01" ? "hang" : "unhang"} ?`;
      }
      this.$confirm(hint, this.langType ? "提示" : "Hint", {
        confirmButtonText: this.langType ? "确定" : "Confirm",
        cancelButtonText: this.langType ? "取消" : "Cancel",
        type: "warning",
      })
        .then(async () => {
          await handSetOrder({ appId: appId, hang: status });
          this.msgSuccess(this.langType ? "操作成功" : "Successed");
          this.getData();
        })
        .catch(() => {});
    },
    // 编辑订单
    edit(data) {
      getOrderDetail(data.appId).then((res) => {
        if (!res.data.addr) {
          res.data.addr = {};
        }
        this.currentOrder = res.data;
        this.currentAppId = data.appId;
        this.showEdit = true;
        this.orderCanEdit = true;
      });
    },
    hideEdit() {
      this.getData();
      this.showEdit = false;
    },
    onUpdateFinish(appId) {
      if (appId) {
        getOrderDetail(appId).then((res) => {
          this.currentOrder = res.data;
        });
      }
    },
    handleChangeOrder(orderType) {
      this.form.sortBy = orderType;
      this.getData();
    },
    remark() {
      this.showRemark = true;
    },
    hideRemark() {
      this.showRemark = false;
    },
    hideShip() {
      this.showShip = false;
      this.getData();
    },
    goReview() {
      const ids = [];
      const orderStatusArray = [];
      let shipFlag = true;

      this.multipleSelection.map((el) => {
        ids.push(el.appNo);
        orderStatusArray.push(el.orderStatus);
        if (!(el.expre && el.expre.shippingMethod)) {
          shipFlag = false;
        }
      });

      if (orderStatusArray.length == 0) {
        this.$message.error("请选择订单");
        return false;
      }

      for (let record of orderStatusArray) {
        if (record != "02") {
          this.$message.info("只有已付款的订单才能审核");
          return false;
        }
      }
      this.currentOrder = {
        appNo: ids.join(","),
      };
      this.showAuditOrder = true;
    },
    hideSendOrder() {
      this.showSendOrder = false;
      this.getData();
    },
    handleClickPreviewImage(index) {
      this.$refs["carouselPreview"].setActiveItem(index);
      this.activeCarousel = index;
    },
    // 复制订单
    copy(data) {
      orderToCopy(data.appId).then((res) => {
        if (!res.data.addr) {
          res.data.addr = {};
        }
        this.currentOrder = res.data;
        this.currentAppId = data.appId;
        this.showCopy = true;
      });
    },
    hideCopy() {
      this.showCopy = false;
    },
    showSale(data) {
      this.currentOrder = data;
      this.showEditSale = true;
    },
    hideEditSale() {
      this.showEditSale = false;
    },
    okEditSale() {
      this.getData();
      this.showEditSale = false;
    },
    okCopyOrder() {
      this.getData();
      this.showCopy = false;
    },
    okAuditOrder() {
      this.getData();
      this.showAuditOrder = false;
    },
    okAcceptOrder() {
      this.getData();
      this.showAcceptOrder = false;
    },
    async exportOrder() {
      let params = Object.assign({}, this.form);

      if (this.form.createTime && this.form.createTime.length > 0) {
        params["beginTime"] = dayjs(this.form.createTime[0]).format(
          "YYYY-MM-DD"
        );
        params["endTime"] = dayjs(this.form.createTime[1]).format("YYYY-MM-DD");
      }

      if (this.form.lineTime && this.form.lineTime.length > 0) {
        params["lineTimeBegin"] = dayjs(this.form.lineTime[0]).format(
          "YYYY-MM-DD"
        );
        params["lineTimeEnd"] = dayjs(this.form.lineTime[1]).format(
          "YYYY-MM-DD"
        );
      }

      if (this.form.sendTime && this.form.sendTime.length > 0) {
        params["sendTimeBegin"] = dayjs(this.form.sendTime[0]).format(
          "YYYY-MM-DD"
        );
        params["sendTimeEnd"] = dayjs(this.form.sendTime[1]).format(
          "YYYY-MM-DD"
        );
      }
      if (this.form.orderTime && this.form.orderTime.length > 0) {
        params["orderTimeBegin"] = dayjs(this.form.orderTime[0]).format(
          "YYYY-MM-DD"
        )
        params["orderTimeEnd"] = dayjs(this.form.orderTime[1]).format(
          "YYYY-MM-DD"
        )
      }
      if (this.multipleSelection.length > 0) {
        let appNos = [];
        this.multipleSelection.map((record) => {
          appNos.push(record.appNo);
        });
        params.appNos = appNos.join(",");
      }

      params.shopIds = params.shopId.join(",");
      params.orderStatus = params.orderStatus.join(",");
      params.appNos = params.appNos.replace("，", ",");
      params.platNos = params.platNo.join(",");
      params.pOperNo = params.pOperNo.join("--");
      params.orderRemarkType = params.orderRemarkType.join(",");
      params.orderRemarkColor = params.orderRemarkColor.join(",");
      params.manufacturer = params.manufacturer.join(",");
      params.state = params.state.join(",");
      params.amazonOrderStatusList = params.amazonOrderStatus.join(",")
      delete params.amazonOrderStatus;
      if (this.currentPathName == "orderFlb") {
        const { tiktok, shopee, lazada } = this.thirdOrderStatus;
        params.amazonOrderStatusList = tiktok.concat(shopee, lazada).join(",");
      }
      let path = this.$route.path;

      if (path.indexOf("lazada") > -1) {
        params.platNos = "03";
      }

      if (path.indexOf("shopee") > -1) {
        params.platNos = "05";
      }

      if (path.indexOf("tiktok") > -1) {
        params.platNos = "10";
      }

      if (path.indexOf("jst") > -1) {
        params.productType = "02";
      } else {
        params.productType = "01";
      }

      if (params.shopIds == "" && this.isCheckShop) {
        let shopId = [];
        for (let record of this.shopList) {
          shopId.push(record.shopId);
        }
        params.shopIds = shopId.join(",");
      }
      if (this.user.userType == "00") {
        delete params["shopIds"];
      }

      delete params["operNos"];
      delete params["platNo"];
      params.hang = undefined;

      if (this.activeName == "notpay") {
        params.orderStatus = "01";
      }

      if (this.activeName == "pay") {
        params.orderStatus = "02";
      }

      if (this.activeName == "produce") {
        params.orderStatus = "03";
      }
      if (this.activeName == "producing") {
        params.orderStatus = "04";
        // params["beginTime"] = undefined
        // params["endTime"] = undefined
      }
      if (this.activeName == "canceled") {
        params.orderStatus = "06";
      }

      if (this.activeName == "sended") {
        params.orderStatus = "05";
        let curDate = new Date();
        let preDate = new Date(curDate.getTime() - 24 * 60 * 60 * 1000 * 7);
        params["beginTime"] = undefined;
        params["endTime"] = undefined;
        // params["lineTimeEnd"] = this.parseTime(
        //   preDate,
        //   "{y}-{m}-{d} {h}:{i}:{s}"
        // )
      }

      if (this.activeName == "hanging") {
        params.hang = "01";
        params.orderStatus = "";
      }

      if (this.activeName == "other") {
        params.orderStatus = "03,04,05,06,07,09";
      }

      if (this.activeName == "sum") {
        params.orderStatus = "03,04,05";
      }

      delete params["createTime"];
      delete params["lineTime"];
      delete params["sendTime"];
      delete params["shopId"];
      delete params["orderTime"];
      this.startLoading();

      await downLoadExcel(
        `/server/order/exportFlbOrder?${qs.stringify(params)}&fileName=` +
          Math.random(),
        Math.random()
      );
      this.endLoading();
    },
    async exportOrderTH() {
      let params = Object.assign({}, this.form);

      if (this.form.createTime && this.form.createTime.length > 0) {
        params["beginTime"] = dayjs(this.form.createTime[0]).format(
          "YYYY-MM-DD"
        );
        params["endTime"] = dayjs(this.form.createTime[1]).format("YYYY-MM-DD");
      }

      if (this.form.lineTime && this.form.lineTime.length > 0) {
        params["lineTimeBegin"] = dayjs(this.form.lineTime[0]).format(
          "YYYY-MM-DD"
        );
        params["lineTimeEnd"] = dayjs(this.form.lineTime[1]).format(
          "YYYY-MM-DD"
        );
      }

      if (this.form.sendTime && this.form.sendTime.length > 0) {
        params["sendTimeBegin"] = dayjs(this.form.sendTime[0]).format(
          "YYYY-MM-DD"
        );
        params["sendTimeEnd"] = dayjs(this.form.sendTime[1]).format(
          "YYYY-MM-DD"
        );
      }
      if (this.form.orderTime && this.form.orderTime.length > 0) {
        params["orderTimeBegin"] = dayjs(this.form.orderTime[0]).format(
          "YYYY-MM-DD"
        )
        params["orderTimeEnd"] = dayjs(this.form.orderTime[1]).format(
          "YYYY-MM-DD"
        )
      }
      if (this.multipleSelection.length > 0) {
        let appNos = [];
        this.multipleSelection.map((record) => {
          appNos.push(record.appNo);
        });
        params.appNos = appNos.join(",");
      }

      params.shopIds = params.shopId.join(",");
      params.orderStatus = params.orderStatus.join(",");
      params.appNos = params.appNos.replace("，", ",");
      params.platNos = params.platNo.join(",");
      params.pOperNo = params.pOperNo.join("--");
      params.orderRemarkType = params.orderRemarkType.join(",");
      params.orderRemarkColor = params.orderRemarkColor.join(",");
      params.manufacturer = params.manufacturer.join(",");
      params.state = params.state.join(",");

      let path = this.$route.path;

      if (path.indexOf("lazada") > -1) {
        params.platNos = "03";
      }

      if (path.indexOf("shopee") > -1) {
        params.platNos = "05";
      }

      if (path.indexOf("tiktok") > -1) {
        params.platNos = "10";
      }

      if (path.indexOf("jst") > -1) {
        params.productType = "02";
      } else {
        params.productType = "01";
      }

      if (params.shopIds == "" && this.isCheckShop) {
        let shopId = [];
        for (let record of this.shopList) {
          shopId.push(record.shopId);
        }
        params.shopIds = shopId.join(",");
      }
      if (this.user.userType == "00") {
        delete params["shopIds"];
      }

      delete params["operNos"];
      delete params["platNo"];
      params.hang = undefined;

      if (this.activeName == "notpay") {
        params.orderStatus = "01";
      }

      if (this.activeName == "pay") {
        params.orderStatus = "02";
      }

      if (this.activeName == "produce") {
        params.orderStatus = "03";
      }
      if (this.activeName == "producing") {
        params.orderStatus = "04";
        // params["beginTime"] = undefined
        // params["endTime"] = undefined
      }
      if (this.activeName == "canceled") {
        params.orderStatus = "06";
      }

      if (this.activeName == "sended") {
        params.orderStatus = "05";
        let curDate = new Date();
        let preDate = new Date(curDate.getTime() - 24 * 60 * 60 * 1000 * 7);
        params["beginTime"] = undefined;
        params["endTime"] = undefined;
        // params["lineTimeEnd"] = this.parseTime(
        //   preDate,
        //   "{y}-{m}-{d} {h}:{i}:{s}"
        // )
      }

      if (this.activeName == "hanging") {
        params.hang = "01";
        params.orderStatus = "";
      }

      if (this.activeName == "other") {
        params.orderStatus = "03,04,05,06,07,09";
      }

      if (this.activeName == "sum") {
        params.orderStatus = "03,04,05";
      }

      delete params["createTime"];
      delete params["lineTime"];
      delete params["sendTime"];
      delete params["shopId"];
      delete params["orderTime"];
      this.startLoading();

      await downLoadExcel(
        `/server/order/exportThOrder?${qs.stringify(params)}&fileName=` +
          Math.random(),
        Math.random()
      );
      this.endLoading();
    },
    // 取消订单
    cancelOrderFn(data) {
      this.$confirm("请确认是否取消订单？", "取消订单", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        cancelOrder({
          appId: data.appId,
        }).then((res) => {
          if (res.code !== 200) {
            this.$message.error("取消失败");
          } else {
            this.getData();
            this.$message({
              type: "success",
              message: "取消成功!",
            });
          }
        });
      });
    },
    async handleQuickOrder(row) {
      try {
        this.$confirm("请确认是否加急订单？", "加急订单", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(async () => {
          this.startLoading();
          let result = await createShip({ appId: row.appId });
          this.$message({
            type: "success",
            message: result.msg,
          });
          this.getData();
          this.endLoading();
        });
      } catch (error) {
        this.endLoading();
      }
    },
    async handleRefund(row) {
      try {
        this.$confirm("请确认是否取消订单？", "取消订单", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.currentOrder = row;
          this.showCancel = true;
        });
      } catch (error) {
        this.endLoading();
      }
    },
    // 恢复订单
    renewOrder(data) {
      this.$confirm("请确认是否恢复订单？", "恢复订单", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        recoveryOrder({
          appId: data.appId,
        }).then((res) => {
          if (res.code !== 200) {
            this.$message.error("恢复失败");
          } else {
            this.getData();
            this.$message({
              type: "success",
              message: "恢复成功!",
            });
          }
        });
      });
    },
    handleOpenDetail(row) {
      let routeUrl = this.$router.resolve({
        path: "/select/custom/product",
        query: { pId: row.pId, designId: row.designId },
      });
      window.open(routeUrl.href, "_blank");
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (
        columnIndex === 0 ||
        columnIndex === 1 ||
        columnIndex === 2 ||
        columnIndex === 10 ||   //原页面打印图是合并显示的，暂时保留
        columnIndex === 11 ||
        columnIndex === 12 ||
        columnIndex === 13 ||
        columnIndex === 14 ||
        columnIndex === 15 ||
        columnIndex === 16 ||
        columnIndex === 17
      ) {
        if (row.isNew && row.count != 0) {
          return {
            rowspan: row.count,
            colspan: 1,
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      }
    },
    async batchSend() {
      if (this.multipleSelection.length == 0) {
        this.msgError("请选择订单");
        return;
      }

      this.$confirm("不是packed状态的订单可能会发货失败，请知悉！", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          let array = [];
          for (let record of this.multipleSelection) {
            let shippingMethod = record.shippingProvider;
            let shippingMethodName = record.shippingProvider;
            let trackingNumber = record.trackingNumber;
            if (record.expreList && record.expreList.length > 0) {
              shippingMethod = record.expreList[0].shippingMethod;
              shippingMethodName = record.expreList[0].shippingMethodName;
              trackingNumber = record.expreList[0].trackingNumber;
            }
            if (!trackingNumber) {
              trackingNumber = record.skuList[0].trackingCode;
            }
            array.push({
              shippingMethod: shippingMethod,
              shippingMethodName: shippingMethodName,
              appId: record.appId,
              trackingNumber: trackingNumber,
            });
          }
          try {
            this.startLoading();
            let result = await batchSendPhByHand(array);
            this.getData();
            this.msgSuccess(result.msg);
            this.endLoading();
          } catch (error) {}
        })
        .catch(() => {});
    },
    handleAppNosBlur() {
      this.form.appNos = this.appNos.replace(/\n/g, ",");
      this.showAppNosTextarea = false;
    },
    handleShowAppsNos() {
      this.appNos = this.form.appNos.replace(/,/g, "\n");
      this.showAppNosTextarea = true;
    },
    batchDownload() {
      if (this.multipleSelection.length == 0) {
        this.msgError("请选择订单");
        return;
      }

      const ids = [];
      this.multipleSelection.map((el) => {
        if (!ids.includes(el.appNo)) {
          ids.push(el.appNo);
        }
      });
      let routeUrl = this.$router.resolve({
        path: "/prod-api/server/order/downloadImage",
        query: { appNos: ids.join(",") },
      });
      window.open(routeUrl.href, "_blank");
    },
    batchDownloadPick() {
      if (this.multipleSelection.length == 0) {
        this.msgError("请选择订单");
        return;
      }

      const ids = [];
      this.multipleSelection.map((el) => {
        if (!ids.includes(el.appNo)) {
          ids.push(el.appNo);
        }
      });
      let routeUrl = this.$router.resolve({
        path: "/prod-api/server/order/downloadPickPdf",
        query: {
          appNos: ids.join(","),
          sortType: this.form.sortType,
          sortBy: this.form.sortBy,
        },
      });
      window.open(routeUrl.href, "_blank");
    },
    batchDownloadCombine() {
      if (this.multipleSelection.length == 0) {
        this.msgError("请选择订单");
        return;
      }

      const ids = [];
      this.multipleSelection.map((el) => {
        if (!ids.includes(el.appNo)) {
          ids.push(el.appNo);
        }
      });
      let routeUrl = this.$router.resolve({
        path: "/prod-api/server/order/downloadExpressPdf",
        query: {
          appNos: ids.join(","),
          sortType: this.form.sortType,
          sortBy: this.form.sortBy,
        },
      });
      window.open(routeUrl.href, "_blank");
    },
    downloadImages() {
      if (this.multipleSelection.length == 0) {
        this.msgError("请选择订单");
        return;
      }

      const ids = [];
      this.multipleSelection.map((el) => {
        if (!ids.includes(el.appNo)) {
          ids.push(el.appNo);
        }
      });
      let routeUrl = this.$router.resolve({
        path: "/prod-api/server/order/downloadOriginalImage",
        query: { appNos: ids.join(",") },
      });
      window.open(routeUrl.href, "_blank");
    },
    downloadImagesTH() {
      if (this.multipleSelection.length == 0) {
        this.msgError("请选择订单");
        return;
      }

      const ids = [];
      this.multipleSelection.map((el) => {
        if (!ids.includes(el.appNo)) {
          ids.push(el.appNo);
        }
      });
      let routeUrl = this.$router.resolve({
        path: "/prod-api/server/order/downloadImageTh",
        query: { appNos: ids.join(",") },
      });
      window.open(routeUrl.href, "_blank");
    },
    async handleRefreshOrder(row) {
      try {
        if (this.multipleSelection.length == 0) {
            this.msgError("请选择订单");
            return;
        }
        this.startLoading()
        this.getData()
        this.multipleSelection.forEach(async({shopId, appNo}) => {
         await freshByAppNo({
            shopId: shopId,
            appNo: appNo,
         })
        })
        
        this.endLoading()
      } catch (error) {}
    },
    async downloadImagesTHNew() {
      if (this.multipleSelection.length == 0) {
        this.msgError("请选择订单");
        return;
      }

      this.startLoading();

      const orders = [];

      this.multipleSelection.map((el) => {
        orders.push({
          appNo: el.appNo,
          attachUrl: el.attachUrl,
          skuList: el.skuList,
        });
      });

      const zip = new JSZip();
      // let folders = []
      for (let record of orders) {
        let folder = zip.folder(record.appNo);

        let folderPrint = folder.folder("打印图");
        let skuIndex = 1;
        for (let sku of record.skuList) {
          let folderSku = folderPrint.folder(
            `${sku.properVal.replace(":", "_")}_${skuIndex}`
          );
          skuIndex++;

          let urls = [];
          for (let image of sku.sOrderSkuPrintPic) {
            let url = await getMinImageByObject(image.picUrl);
            urls.push(url);
          }

          await Promise.all(
            urls.map(async (imageUrl, index) => {
              index++;
              const imageData = await this.getImageData(imageUrl);
              folderSku.file(
                `${dayjs(new Date()).format("YYYYMMDD")}_${
                  record.appNo
                }_${index}.png`,
                imageData
              );
            })
          );
        }

        if (record.attachUrl) {
          let pdfData = await this.getImageData(record.attachUrl);
          folder.file(`${record.appNo}.pdf`, pdfData);
        }
      }

      // 生成 zip 压缩包，并将其下载到本地
      zip
        .generateAsync({ type: "blob" })
        .then((content) => {
          const url = URL.createObjectURL(content);
          const link = document.createElement("a");
          link.href = url;
          link.download = dayjs(new Date()).format("YYYYMMDDHHmmss") + ".zip";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          this.endLoading();
        })
        .catch(() => {
          this.endLoading();
        });
    },
    async getImageData(imageUrl) {
      const response = await axios.get(imageUrl, { responseType: "blob" });
      return response.data;
    },
    getHourHint(slaTimeStamp, receiveTime) {
      if (slaTimeStamp) {
        var reDate = /\d{4}-\d{1,2}-\d{1,2} /;
        slaTimeStamp = new Date(
          (reDate.test(slaTimeStamp)
            ? slaTimeStamp
            : "2018-1-1 " + slaTimeStamp
          ).replace(/-/g, "/")
        );
      }
      if (slaTimeStamp && !receiveTime) {
        let s2 = new Date();
        var ms = Math.round(
          (slaTimeStamp.getTime() - s2.getTime()) / 1000 / 60 / 60
        );
        if (this.langType) {
          if (ms >= 0) {
            return "将在" + ms + "小时后过期";
          } else {
            return "已过期" + -ms + "小时";
          }
        } else {
          if (ms >= 0) {
            return "Expired in " + ms + " hours";
          } else {
            return -ms + " hours overdue";
          }
        }
      } else if (slaTimeStamp && receiveTime) {
        let s2 = new Date(receiveTime);
        var ms = Math.round(
          (s2.getTime() - slaTimeStamp.getTime()) / 1000 / 60 / 60
        );

        if (this.langType) {
          if (ms > 0) {
            return "超期" + ms + "小时发货";
          } else {
            return "正常发货";
          }
        } else {
          if (ms > 0) {
            return "overdue " + ms + " hours to send";
          } else {
            return "Normal Send";
          }
        }
      } else {
        return "";
      }
    },
    getHourColor(slaTimeStamp, receiveTime) {
      let hintColor = "red";
      if (slaTimeStamp) {
        var reDate = /\d{4}-\d{1,2}-\d{1,2} /;
        slaTimeStamp = new Date(
          (reDate.test(slaTimeStamp)
            ? slaTimeStamp
            : "2018-1-1 " + slaTimeStamp
          ).replace(/-/g, "/")
        );
      }
      if (slaTimeStamp && receiveTime) {
        let s2 = new Date(receiveTime);
        var ms = Math.round(
          (s2.getTime() - slaTimeStamp.getTime()) / 1000 / 60 / 60
        );
        if (ms <= 0) {
          hintColor = "#00b78d";
        }
      }
      return hintColor;
    },
    goRelate(data) {
      this.$router.push({
        path: "/order/order_aid/toMatchOrder",
        query: {
          appNo: data.appNo,
        },
      });
    },
    handleShowUploadLabel(row) {
      this.importForm.appId = row.appId;
      this.$refs.inputer ? (this.$refs.inputer.value = "") : "";
      this.showUploadLabel = true;
    },
    uploadFn() {
      let inputDOM = this.$refs.inputer;
      let file = inputDOM.files;

      this.importForm.file = file;
    },
    handleUploadLabel() {
      this.$refs["importForm"].validate((valid) => {
        if (valid) {
          this.startLoading();
          let formData = new FormData();

          formData.append("file", this.importForm.file[0]);
          formData.append("appId", this.importForm.appId);

          uploadTb(formData)
            .then((res) => {
              if (res.code !== 200) {
                this.$message.error("上传失败");
              } else {
                this.$message.success("上传成功");
                this.showModal = false;
                // this.successOrder = res.rows
                this.showUploadLabel = false;
                this.getData();
              }
              this.endLoading();
            })
            .catch(() => {
              this.endLoading();
            });
        }
      });
    },
    handleShowDetail(record) {
      this.productList = record.shipList;
      this.detailVisible = true;
    },
    handleCloseDetail() {
      this.detailVisible = false;
    },
    handleOpenProduct(row) {
      let routeUrl = "";
      if (row.productType == "01") {
        routeUrl = this.$router.resolve({
          path: "/select/custom/product",
          query: { designId: row.designId },
        });
      } else {
        routeUrl = this.$router.resolve({
          path: "/select/custom/product",
          query: { pId: row.pId },
        });
      }

      window.open(routeUrl.href, "_blank");
    },
    caculateProduct(data) {
      let count = 0;
      for (let record of data) {
        count += Number(record.num);
      }
      return count;
    },
    handleExpand(row) {
      row.expand = !row.expand;
      row.skuList = this._.clone(row.skuList);
    },
    handleCheckAll() {
      this.form.shopId = [];
      for (let record of this.shopList) {
        this.form.shopId.push(record.shopId);
      }
    },
    throttle(fn, wait) {
      var pre = Date.now();
      return function () {
        var context = this;
        var args = arguments;
        var now = Date.now();
        if (now - pre >= wait) {
          fn.apply(context, args);
          pre = Date.now();
        }
      };
    },
    handleScroll() {
      var menu = this.scrollMenu;
      //获取页面的滚动距离
      var scrollHeight =
        document.documentElement.scrollTop || document.body.scrollTop;
      //滚动到一定位置 div固定到顶部 js实现吸顶
      if (this.objectHeight < scrollHeight) {
        menu.style.position = "fixed";
        menu.style.top = 0;
        menu.style.width = "calc(100% - 290px)";
        menu.style.padding = "8px 0";
      } else {
        menu.style.position = "relative";
        menu.style.width = "100%";
        menu.style.padding = "0";
      }
    },
    handleChangeLangType() {
      localStorage.setItem("langType", this.langType ? "1" : "0");
      window.setTimeout(() => {
        this.$nextTick(() => {
          let totals = document.querySelectorAll(".el-pagination__total");
          for (let record of totals) {
            // let text = record.innerText
            //   .replace("共", "")
            //   .replace("条", "")
            //   .replace("total: ", "")
            //   .replace(" records", "")
            // if (this.langType) {
            //   text = "共" + text + "条"
            // } else {
            //   text = "total: " + text + " records"
            // }
            // record.innerText = text
          }

          let jumps = document.querySelectorAll(".el-pagination__jump");
          for (let jump of jumps) {
            if (this.langType) {
              jump.childNodes[0].nodeValue = "前往";
              jump.childNodes[2].nodeValue = "页";
            } else {
              jump.childNodes[0].nodeValue = "Go to";
              jump.childNodes[2].nodeValue = "page";
            }
          }

          let inputs = document.querySelectorAll(
            ".el-pagination__sizes .el-input__inner"
          );
          for (let input of inputs) {
            let value = input.value.replace("条/页", "").replace("/page", "");
            if (this.langType) {
              value = value + "条/页";
            } else {
              value = value + "/page";
            }
            input.value = value;
          }
        });
      }, 100);
    },
    handleChangeScreenType() {
      localStorage.setItem("screenType", this.screenType ? "1" : "0");
      if (this.screenType) {
        document.querySelector(".el-aside").style.width = "1px";
        document.querySelector(".tags").style.left = "10px";
        document.querySelector(".tags").style.width = "calc(100vw - 10px)";
      } else {
        document.querySelector(".el-aside").style.width = "200px";
        document.querySelector(".tags").style.left = "217px";
        document.querySelector(".tags").style.width = "calc(100vw - 359px)";
      }
    },
    // 批量备注
    batchRemarkEvent() {
      if (this.multipleSelection.length == 0) {
        this.msgError("请选择订单");
        return;
      }

      let ids = []
      this.multipleSelection.map((el) => {
        ids.push(el.appId);
      });

      this.$prompt('请输入备注', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputValue: this.batchRemark,
      }).then(({ value }) => {
          setAdminRemark({
            adminRemark: value,
            appId: ids.join(",")
          }).then(res => {
              this.$message({
                  type: 'success',
                  message: '批量修改成功'
              });
          }).catch(err =>{

          });
      }).catch(() => {
          this.$message({
              type: 'info',
              message: '取消输入'
          });
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.form-body {
  padding: 10px 20px;
}

.form-body .item {
  min-height: 42px;
}

.form-body .item.right {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.table-body {
  margin-top: 10px;
  border: 1px solid #ebeef5;
  background: #fff;
  font-size: 12px;
  overflow: hidden;
}

.table-body .top {
  padding: 0 0 8px 0;
  background: #fff;
  padding-right: 0;
}

.table-body > .table {
  margin-bottom: 10px;
}

.table-info-wrap {
  margin-bottom: -10px;
}

.table-info {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #ebeef5;
  margin-bottom: 10px;
  padding: 0 10px 0 10px;
}

.table-info:last-child {
  margin-bottom: 0;
  border-bottom: 0;
}

.table-info .left {
  margin-right: 12px;
  width: 111px;
  height: 111px;
  margin-bottom: 10px;
  position: relative;
}

.table-info .left .mini-img {
  width: 109px;
  height: 109px;
  border: 1px solid #dddddd;
}

.table-info .right {
  font-size: 12px;
  width: 200px;
  padding: 0 0 4px 0;
}

.loan-wrap {
  display: flex;
  flex-direction: column;
  display: flex;
  flex-direction: column;
  padding: 0 10px;
  font-size: 12px;
  text-align: left;
}

.loan-wrap .title.lw40 {
  width: 24px;
}

.loan-wrap .title {
  width: 48px;
  display: inline-block;
  text-align: justify;
  text-align-last: justify;
}

.operate {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.operate .link {
  font-size: 12px;
  color: #4934b2;
  cursor: pointer;
}

.custom-order ::v-deep .el-select {
  width: 100%;
}

.custom-order ::v-deep .el-date-editor {
  width: 100%;
}
.preview-area {
  overflow: hidden;
  .carousel {
    width: 600px;
    float: left;
    .el-carousel__item {
      text-align: center;
    }
    ::v-deep .el-carousel__container {
      height: 500px;
    }
    ::v-deep .el-carousel__indicators {
      display: none;
    }
    img {
      width: 500px;
      height: 500px;
    }
  }
  .preview-list {
    width: 130px;
    float: left;
    height: 500px;
    margin: 0 0 0 16px;
    overflow-y: auto;
    .preview-list-item {
      border: 1px solid #e5e5e5;
      margin: 0 8px 15px 0;
      box-sizing: border-box;
      width: 111px;
      height: 111px;
      position: relative;
      cursor: pointer;
      .preview-text {
        display: none;
        position: absolute;
        bottom: 0;
        left: 0;
        text-align: center;
        width: 100%;
        background: rgba(0, 0, 0, 0.4);
        color: #fff;
        padding: 0.05rem 0;
        font-size: 0.14rem;
        z-index: 10;
        font-size: 14px;
      }
      &:hover .preview-text {
        display: block;
      }
      &.is-active .preview-text {
        display: block;
        background: #4934b2;
      }
    }

    img {
      width: 109px;
      height: 109px;
    }
    .is-active {
      border: 1px solid #4934b2;
    }
  }
  .color-picker {
    overflow: hidden;
    margin: 16px 8px 0 0;
    ul {
      overflow: hidden;
      padding: 0px 0 0 266px;
    }
  }

  .color-picker-list li,
  .color-picker-list-hover li {
    background-color: #fff;
    width: 24px;
    height: 24px;
    border-radius: 4px;
    border: #d6d2d2 solid 1px;
    margin-left: 2px;
    padding: 1px;
    float: left;
  }
  .color-picker-list li.cur {
    border: #4934b2 solid 2px;
  }
  .color-picker-list li a,
  .color-picker-list-hover li a {
    width: 24px;
    height: 24px;
    display: table;
  }
}
.product-type {
  position: absolute;
  left: 4px;
  top: 4px;
  border-color: rgb(255, 144, 0);
  background-color: rgb(255, 144, 0);
  height: 20px;
  padding: 0 5px;
  line-height: 19px;
  color: #fff;
  font-size: 12px;
  border-radius: 5px;
}
.product-tag {
  position: absolute;
  left: 4px;
  top: 4px;
  border-color: #ff9000;
  background-color: #ff9000;
  height: 20px;
  padding: 0 5px;
  line-height: 19px;
  color: #fff;
  font-size: 12px;
  border-radius: 5px;
}
.table-menu {
  width: 100%;
  z-index: 100;
  background: #ffffff;
}
.custom-order ::v-deep .el-tabs__item.is-active {
  background: #ffffff;
}
.fullscreen {
  position: absolute;
  right: 200px;
  top: 106px;
  z-index: 100;
}

.language {
  position: absolute;
  right: 50px;
  top: 106px;
  z-index: 100;
}

.textareaBox {
  display: block;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
}
.btnIconDown {
  position: absolute;
  left: 5px;
  top: -4px;
  font-size: 16px;
  color: #999;
  cursor: pointer;
  padding: 4px 10px;
  z-index: 5;
}
.batch_txt {
  font-size: 13px;
  transform: initial !important;
  color: #3d2c96;
}
.batch_inputbox ::v-deep .el-input__inner {
  padding: 0 50px;
}
.form-body ::v-deep .el-col-8 {
  margin-top: 8px;
}
.design_flag_container {
  position: relative;
  width: 98px;
  height: 98px;
  margin: 0 auto;
}
.design_flag {
  position: absolute;
  top: 0;
  left: 0;
  background-color: #aaaaaa;
  padding: 0 4px;
  color: #ffffff;
}
</style>
